// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"22\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><line x1=\"18\" y1=\"6\" x2=\"6\" y2=\"18\" /><line x1=\"6\" y1=\"6\" x2=\"18\" y2=\"18\" /></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNjEyIDQ1NCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNjEyIDQ1NDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+LnN0MHtmaWxsOiNGRkZGRkY7fTwvc3R5bGU+PHBhdGggaWQ9Inl0cC1pZC0yMyIgY2xhc3M9InN0MCIgZD0iTTI4MiwyNDJoMTM2VjE0MEgyODJWMjQyTDI4MiwyNDJ6IE0xMTksMTA2djIzOC4zYzAsMTguNywxNS4zLDMzLjcsMzQsMzMuN2gzMDZjMTguNywwLDM0LTE1LDM0LTMzLjdWMTA2YzAtMTguNy0xNS4zLTM0LTM0LTM0SDE1M0MxMzQuMyw3MiwxMTksODcuMywxMTksMTA2TDExOSwxMDZ6IE0xNTMsMTA1LjdoMzA2djIzOC45SDE1M1YxMDUuN0wxNTMsMTA1Ljd6Ii8+PC9zdmc+", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDI0IDI0OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHN0eWxlIHR5cGU9InRleHQvY3NzIj4uc3Qwe2ZpbGw6I0ZGRkZGRjt9PC9zdHlsZT48Zz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMi4wMDAwMDAsIDEyLjAwMDAwMCkgc2NhbGUoLTEsIDEpIHRyYW5zbGF0ZSgtMTIuMDAwMDAwLCAtMTIuMDAwMDAwKSAiPjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik01LDE5VjVoMTR2N2gyVjVjMC0xLjEtMC45LTItMi0ySDVDMy45LDMsMywzLjksMyw1djE0YzAsMS4xLDAuOSwyLDIsMmg3di0ySDV6IE0yMSwxNGgtMnYzLjZMOS4yLDcuOEw3LjgsOS4ybDkuOCw5LjhIMTR2Mmg3VjE0eiIvPjwvZz48L2c+PC9zdmc+", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@400;500&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fade-enter {
  opacity: 0; }

.fade-enter-active {
  height: auto;
  opacity: 1;
  transition: opacity 300ms linear; }

.fade-enter-done {
  height: auto; }

.fade-exit {
  opacity: 1; }

.fade-exit-active {
  height: 0;
  opacity: 0;
  transition: opacity 300ms linear; }

.fade-exit-done {
  opacity: 0; }

.fade-slide-enter {
  opacity: 0;
  transform: translateY(10px); }

.fade-slide-enter-active {
  opacity: 1;
  transform: translateY(0);
  transition: all 300ms cubic-bezier(0.35, 0.35, 0.35, 0.98); }

.fade-slide-exit {
  opacity: 1;
  transform: translateY(0);
  transition: all 300ms cubic-bezier(0.35, 0.35, 0.35, 0.98); }

.fade-slide-exit-active {
  opacity: 0;
  transition: all 300ms linear; }

.fade-slide-exit-done {
  opacity: 0; }

.slide-in-enter,
.slide-in-appear {
  opacity: .2;
  transform: translateY(10px); }

.slide-in-enter-active,
.slide-in-appear-active {
  opacity: 1;
  transform: translateY(0);
  transition: all 300ms cubic-bezier(0.35, 0.35, 0.35, 0.98); }

.slide-in-exit,
.slide-in-exit-active {
  display: none; }

.slide-enter,
.slide-appear {
  opacity: 0;
  transform: translateY(10px); }

.slide-enter-active,
.slide-appear-active {
  opacity: 1;
  transform: translateY(0);
  transition: all 300ms cubic-bezier(0.35, 0.35, 0.35, 0.98) 300ms; }

.slide-exit,
.slide-exit-active {
  opacity: 0;
  transform: translateY(10px);
  transition: all 300ms cubic-bezier(0.35, 0.35, 0.35, 0.98); }

.slide-enter-done {
  display: block; }

.slide-exit-done {
  display: none; }

.scale-in-enter,
.scale-in-appear {
  opacity: 0;
  transform: scale(0.4);
  transform-origin: 100% 100%; }

.scale-in-enter-active,
.scale-in-appear-active {
  opacity: 1;
  transform: scale(1);
  transform-origin: 100% 100%;
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.1s;
  transition-property: transform, opacity; }

.scale-in-exit {
  opacity: 1;
  transform: scale(1); }

.scale-in-exit-active {
  opacity: 0;
  transform: scale(0.4);
  transform-origin: 100% 100%;
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transition-property: transform, opacity; }

.slide-in {
  animation-delay: .15s;
  animation-duration: .2s;
  animation-fill-mode: both;
  animation-name: slideIn;
  animation-timing-function: cubic-bezier(0.35, 0.35, 0.35, 0.98);
  transform-origin: bottom;
  will-change: transform, opacity; }

.fade-in,
.fade-in-left,
.fade-in-right {
  animation-delay: .15s;
  animation-duration: .3s;
  animation-fill-mode: both;
  animation-timing-function: ease-in; }

.fade-in {
  animation-name: fadeIn; }

.fade-in-right {
  animation-name: fadeInRight; }

.fade-in-left {
  animation-name: fadeInLeft; }

@-webkit-keyframes animationPulse {
  0% {
    box-shadow: 0 0 0 0;
    opacity: .5; }
  40% {
    box-shadow: 0 0 0 8px;
    opacity: 0; }
  80% {
    box-shadow: 0 0 0 8px;
    opacity: 0; }
  100% {
    box-shadow: 0 0 0 0;
    opacity: 0; } }

@-moz-keyframes animationPulse {
  0% {
    box-shadow: 0 0 0 0;
    opacity: .5; }
  40% {
    box-shadow: 0 0 0 8px;
    opacity: 0; }
  80% {
    box-shadow: 0 0 0 8px;
    opacity: 0; }
  100% {
    box-shadow: 0 0 0 0;
    opacity: 0; } }

@keyframes animationPulse {
  0% {
    box-shadow: 0 0 0 0;
    opacity: .5; }
  40% {
    box-shadow: 0 0 0 8px;
    opacity: 0; }
  80% {
    box-shadow: 0 0 0 8px;
    opacity: 0; }
  100% {
    box-shadow: 0 0 0 0;
    opacity: 0; } }

@-webkit-keyframes animationSpin {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(360deg); } }

@-moz-keyframes animationSpin {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(360deg); } }

@keyframes animationSpin {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(360deg); } }

@-webkit-keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0); }
  20%, 80% {
    transform: translate3d(2px, 0, 0); }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0); }
  40%, 60% {
    transform: translate3d(4px, 0, 0); } }

@-moz-keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0); }
  20%, 80% {
    transform: translate3d(2px, 0, 0); }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0); }
  40%, 60% {
    transform: translate3d(4px, 0, 0); } }

@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0); }
  20%, 80% {
    transform: translate3d(2px, 0, 0); }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0); }
  40%, 60% {
    transform: translate3d(4px, 0, 0); } }

@-webkit-keyframes pop {
  from {
    opacity: 0;
    transform: scale(0.5);
    transform-origin: 50% 50%; }
  to {
    opacity: 1;
    transform: scale(1);
    transform-origin: 50% 50%; } }

@-moz-keyframes pop {
  from {
    opacity: 0;
    transform: scale(0.5);
    transform-origin: 50% 50%; }
  to {
    opacity: 1;
    transform: scale(1);
    transform-origin: 50% 50%; } }

@keyframes pop {
  from {
    opacity: 0;
    transform: scale(0.5);
    transform-origin: 50% 50%; }
  to {
    opacity: 1;
    transform: scale(1);
    transform-origin: 50% 50%; } }

@-webkit-keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(10px); }
  to {
    opacity: 1;
    transform: translateY(0); } }

@-moz-keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(10px); }
  to {
    opacity: 1;
    transform: translateY(0); } }

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(10px); }
  to {
    opacity: 1;
    transform: translateY(0); } }

@-webkit-keyframes fadeIn {
  from {
    opacity: 0; }
  to {
    opacity: 1; } }

@-moz-keyframes fadeIn {
  from {
    opacity: 0; }
  to {
    opacity: 1; } }

@keyframes fadeIn {
  from {
    opacity: 0; }
  to {
    opacity: 1; } }

@-webkit-keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(10px); }
  to {
    opacity: 1;
    transform: none; } }

@-moz-keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(10px); }
  to {
    opacity: 1;
    transform: none; } }

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(10px); }
  to {
    opacity: 1;
    transform: none; } }

@-webkit-keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-10px); }
  to {
    opacity: 1;
    transform: none; } }

@-moz-keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-10px); }
  to {
    opacity: 1;
    transform: none; } }

@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-10px); }
  to {
    opacity: 1;
    transform: none; } }

html,
body,
#root,
.salesmatch-widget {
  height: 100%; }

body {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  -o-box-sizing: border-box;
  box-sizing: border-box;
  font-family: "Poppins", Helvetica, Arial, sans-serif;
  margin: 0; }

.salesmatch-widget {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  -o-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 14px;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  line-height: 1.5;
  margin: 0; }
  .salesmatch-widget button,
  .salesmatch-widget input,
  .salesmatch-widget textarea {
    font-family: "Poppins", Helvetica, Arial, sans-serif; }

.icon {
  height: 40px; }
  .icon.white {
    fill: #fff; }
  .icon.attach {
    fill: #686868;
    height: 35px;
    stroke: #686868; }

a {
  color: #007bff; }

.loader {
  -webkit-animation-delay: 0;
  -webkit-animation-duration: 1s;
  -webkit-animation-name: animationSpin;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;
  -moz-animation-delay: 0;
  -moz-animation-duration: 1s;
  -moz-animation-name: animationSpin;
  -moz-animation-iteration-count: infinite;
  -moz-animation-timing-function: linear;
  animation-delay: 0;
  animation-duration: 1s;
  animation-name: animationSpin;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  border: 2px solid rgba(0, 0, 0, 0.3);
  border-radius: 50%;
  border-top: 2px solid rgba(0, 0, 0, 0.2);
  height: 20px;
  margin-right: -10px;
  margin-top: -10px;
  position: absolute;
  right: 50%;
  top: 50%;
  width: 20px; }
  .loader.bigger {
    height: 28px;
    margin-right: -14px;
    margin-top: 0;
    width: 28px; }
  .loader.top-space {
    margin-top: 100px; }

.erxes-tooltip {
  position: relative; }
  .erxes-tooltip:hover {
    cursor: pointer; }
    .erxes-tooltip:hover::before {
      opacity: 1;
      transform: translateY(15%); }
  .erxes-tooltip::before {
    background: #fff;
    border-radius: 10px;
    border: 1px solid var(--border);
    color: #333333;
    content: attr(data-tooltip);
    font-size: 12px;
    left: auto;
    max-width: 150px;
    opacity: 0;
    overflow: hidden;
    padding: 5px 10px;
    pointer-events: none;
    position: absolute;
    right: 0;
    text-align: center;
    text-overflow: ellipsis;
    top: 100%;
    transform: translateY(0%);
    transition: transform 0.3s cubic-bezier(0.2, 1, 0.2, 1), opacity 0.2s cubic-bezier(0.2, 1, 0.2, 1);
    white-space: nowrap;
    will-change: transform, opacity;
    z-index: 1; }
  .erxes-tooltip.tooltip-center::before {
    left: -100%; }

.erxes-button {
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  background: #3ccc38;
  border: 0;
  border-radius: calc(\$border-radius / 2);
  color: #fff;
  font-size: 12px;
  outline: 0;
  padding: 10px 20px;
  position: relative; }
  .erxes-button span {
    color: #fff; }
  .erxes-button:hover, .erxes-button:focus {
    background: #34bb30;
    cursor: pointer;
    text-decoration: none; }
  .erxes-button.btn-block {
    display: block;
    width: 100%; }
  .erxes-button.disabled {
    cursor: not-allowed;
    opacity: 0.7; }
  .erxes-button.btn-primary {
    background: #FD5C12; }
    .erxes-button.btn-primary:hover, .erxes-button.btn-primary:focus {
      background: #f34e02; }
  .erxes-button.btn-outline {
    background: transparent;
    border: 1px solid #888;
    color: #686868; }
    .erxes-button.btn-outline:hover, .erxes-button.btn-outline:focus {
      background: transparent;
      opacity: 0.8; }
  .erxes-button.hasMargin {
    margin-right: 20px; }

.erxes-objectlist-button {
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  background: #ea475d;
  border: 0;
  border-radius: calc(\$border-radius / 2);
  color: #fff;
  font-size: 12px;
  outline: 0;
  padding: 10px 20px;
  position: relative; }
  .erxes-objectlist-button span {
    color: #fff; }
  .erxes-objectlist-button:hover, .erxes-objectlist-button:focus {
    background: #e73049;
    cursor: pointer;
    text-decoration: none; }
  .erxes-objectlist-button.btn-block {
    display: block; }
  .erxes-objectlist-button.disabled {
    cursor: not-allowed;
    opacity: 0.7; }
  .erxes-objectlist-button.btn-primary {
    background: #FD5C12; }
    .erxes-objectlist-button.btn-primary:hover, .erxes-objectlist-button.btn-primary:focus {
      background: #f34e02; }
  .erxes-objectlist-button.btn-outline {
    background: transparent;
    border: 1px solid #888;
    color: #686868; }
    .erxes-objectlist-button.btn-outline:hover, .erxes-objectlist-button.btn-outline:focus {
      background: transparent;
      opacity: 0.8; }

.erxes-objectlist-cancel-button {
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  background: #eaebed;
  border: 0;
  border-radius: calc(\$border-radius / 2);
  color: #888888;
  font-size: 12px;
  outline: 0;
  padding: 10px 20px;
  position: relative; }
  .erxes-objectlist-cancel-button span {
    color: #888888; }
  .erxes-objectlist-cancel-button:hover, .erxes-objectlist-cancel-button:focus {
    background: #dcdee1;
    cursor: pointer;
    text-decoration: none; }
  .erxes-objectlist-cancel-button.btn-block {
    display: block; }
  .erxes-objectlist-cancel-button.disabled {
    cursor: not-allowed;
    opacity: 0.7; }
  .erxes-objectlist-cancel-button.btn-primary {
    background: #FD5C12; }
    .erxes-objectlist-cancel-button.btn-primary:hover, .erxes-objectlist-cancel-button.btn-primary:focus {
      background: #f34e02; }
  .erxes-objectlist-cancel-button.btn-outline {
    background: transparent;
    border: 1px solid #888;
    color: #686868; }
    .erxes-objectlist-cancel-button.btn-outline:hover, .erxes-objectlist-cancel-button.btn-outline:focus {
      background: transparent;
      opacity: 0.8; }

.erxes-form-fields {
  margin-right: -20px; }
  .erxes-form-fields .form-group {
    padding-right: 20px;
    box-sizing: border-box;
    width: 100%; }

.form-control {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  -o-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  -webkit-appearance: none;
  background-color: #f1f1f1;
  border-radius: 10px;
  color: #111111;
  display: block;
  font-size: 14px;
  height: 40px;
  line-height: 1.42857143;
  margin-top: 8px;
  outline: 0;
  width: 100%;
  padding: 10px; }
  .form-control.compact {
    height: 30px;
    padding: 5px; }
  .form-control::placeholder {
    color: #808080; }
  .form-control[type="checkbox"], .form-control[type="radio"] {
    display: inline-block;
    height: inherit;
    margin: 0 8px 5px 0;
    width: inherit;
    background: none;
    box-shadow: none;
    -webkit-appearance: checkbox; }
  .form-control[type="radio"] {
    -webkit-appearance: radio; }

select.form-control,
select.form-control:focus,
.select.form-control,
.select.form-control:focus {
  background: url(http://cdn1.iconfinder.com/data/icons/cc_mono_icon_set/blacks/16x16/br_down.png) no-repeat right;
  background-size: 8px;
  background-position-x: calc(100% - 10px); }

.select.form-control {
  height: auto;
  min-height: 36px; }

.msf_multiselect_container .msf_multiselect {
  border: 1px solid #e4e4e4;
  list-style-type: none;
  margin: 0;
  padding: 0;
  position: absolute;
  z-index: 240; }

.msf_multiselect li {
  padding: 5px 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin: 0 10px 3px 10px;
  border-radius: 4px; }
  .msf_multiselect li:hover, .msf_multiselect li:focus, .msf_multiselect li.active {
    background-color: #f0f0f0; }

.msf_multiselect_container .msf_multiselect {
  max-height: 300px;
  overflow: auto;
  background-color: #fff;
  right: 20px;
  left: 20px; }

.msf_multiselect_container .form-control .selectedLabels {
  padding: 1px 6px;
  background: #f0f0f0;
  color: #768192;
  border: 1px solid #d8dbe0;
  border-radius: 25px;
  display: inline-block;
  font-size: 12px;
  margin: 3px 6px 3px 0; }

.msf_multiselect_container .closeBtn {
  padding-left: 4px;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.5);
  font-weight: bold; }

.msf_multiselect_container .closeBtn.readOnly {
  cursor: unset; }

.msf_multiselect_container .hidden {
  display: none !important; }

.msf_multiselect .searchbox {
  width: -moz-available;
  width: -webkit-fill-available;
  padding: 8px;
  margin: 0;
  border: 0;
  border-bottom: 1px solid #ddd; }
  .msf_multiselect .searchbox:focus {
    outline: 0;
    border-color: #2196f3; }

.msf_multiselect_container .msf_multiselect.offdropdown {
  position: unset; }

.form-group {
  margin-bottom: 15px; }
  .form-group.compact {
    margin-bottom: 0; }
  .form-group .control-label {
    font-weight: 500;
    max-width: 100%; }
    .form-group .control-label > .required {
      margin-left: 2px;
      color: #ff0000; }
  .form-group .description {
    color: #686868;
    display: block;
    font-size: 13px; }
    .form-group .description p {
      margin: 0; }
    .form-group .description ul {
      padding-left: 20px; }
  .form-group .check-control {
    margin-top: 8px; }
  .form-group textarea.form-control {
    height: auto;
    min-height: 70px; }
  .form-group .error {
    color: #ea475d;
    font-size: 12px;
    margin-left: 4px; }

.erxes-callout-body {
  color: #5c5c5c;
  display: block;
  margin-bottom: 10px;
  overflow: hidden;
  width: 100%; }
  .erxes-callout-body img {
    float: left;
    margin-right: 10px;
    max-width: 30%; }

::-webkit-scrollbar {
  border-radius: 0;
  width: 8px; }

::-webkit-scrollbar-thumb {
  background: rgba(215, 215, 215, 0.7);
  border-radius: 4px;
  box-shadow: inset 0 -3px 0 0 transparent, inset 0 3px 0 0 transparent; }

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05); }

.salesmatch-launcher {
  animation: pop 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) 1;
  background-color: #ED3D07;
  background-image: url("https://cdn.salesmatch.ai/portal-demo.salesmatch.ai_0.08122210118098172chat.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 28px;
  bottom: 8px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  color: #ED3D07;
  cursor: pointer;
  height: 56px;
  left: auto;
  line-height: 56px;
  margin-left: auto;
  margin-top: auto;
  pointer-events: auto;
  position: fixed !important;
  right: 0;
  text-align: center;
  top: auto;
  transition: box-shadow .3s ease-in-out, background-image .3s ease-in;
  width: 56px;
  z-index: 2147483646; }
  .salesmatch-launcher span {
    background: #ea475d;
    border-radius: 10px;
    color: #fff;
    display: block;
    font-size: 10px;
    height: 20px;
    line-height: 20px;
    position: absolute;
    right: -2px;
    text-align: center;
    top: -5px;
    width: 20px; }
  .salesmatch-launcher.close, .salesmatch-launcher.close-launcher {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
    background-size: 20px !important;
    background-position: 50%;
    transition: box-shadow .3s ease-in-out, background-image .3s ease-in; }
    .salesmatch-launcher.close::before, .salesmatch-launcher.close-launcher::before {
      animation: none; }
  .salesmatch-launcher::before {
    -webkit-animation-delay: 0.5s;
    -webkit-animation-duration: 3s;
    -webkit-animation-name: animationPulse;
    -webkit-animation-iteration-count: 10;
    -webkit-animation-timing-function: linear;
    -moz-animation-delay: 0.5s;
    -moz-animation-duration: 3s;
    -moz-animation-name: animationPulse;
    -moz-animation-iteration-count: 10;
    -moz-animation-timing-function: linear;
    animation-delay: 0.5s;
    animation-duration: 3s;
    animation-name: animationPulse;
    animation-iteration-count: 10;
    animation-timing-function: linear;
    border-radius: 50%;
    color: inherit;
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%; }
  .salesmatch-launcher.alternative-launcher {
    width: 120px;
    height: 120px; }

.erxes-messenger-embed .erxes-topbar {
  border-radius: 0; }

.erxes-topbar {
  background: #ED3D07;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  color: #fff;
  flex-shrink: 0;
  text-align: center;
  width: 100%; }
  .erxes-topbar .topbar-button {
    width: auto;
    height: auto;
    line-height: initial; }
    .erxes-topbar .topbar-button-trigger {
      display: flex;
      justify-content: start;
      align-items: center;
      gap: .5rem; }
  .erxes-topbar .erxes-middle {
    display: inline-block; }

.topbar-button {
  -webkit-transition: background 0.3s ease-in-out;
  -moz-transition: background 0.3s ease-in-out;
  -ms-transition: background 0.3s ease-in-out;
  -o-transition: background 0.3s ease-in-out;
  transition: background 0.3s ease-in-out;
  background: none;
  border: 0;
  cursor: pointer;
  display: block;
  outline: none;
  padding: 0;
  text-align: center;
  position: relative;
  z-index: 100; }
  .topbar-button.dropdown-open ul {
    visibility: visible;
    opacity: 1; }
  .topbar-button ul {
    -webkit-box-shadow: 0 7px 25px 5px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0 7px 25px 5px rgba(0, 0, 0, 0.1);
    box-shadow: 0 7px 25px 5px rgba(0, 0, 0, 0.1);
    -webkit-transition: all 0.2s ease-in-out;
    -moz-transition: all 0.2s ease-in-out;
    -ms-transition: all 0.2s ease-in-out;
    -o-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
    background-color: var(--accent);
    border-radius: 10px;
    border-top-right-radius: 0;
    font-size: var(--font-size-xs);
    list-style: none;
    position: absolute;
    right: 0;
    padding-block: 10px;
    margin: 0;
    text-align: left;
    top: 100%;
    transform: translateY(10px);
    display: flex;
    flex-direction: column;
    gap: 5px;
    cursor: default;
    overflow: hidden;
    visibility: hidden;
    opacity: 0; }
    .topbar-button ul li a {
      padding-inline: 10px;
      white-space: nowrap;
      text-decoration: none;
      color: var(--accent-foreground);
      display: block; }
      .topbar-button ul li a:hover {
        text-decoration: underline; }

.erxes-staff-profile {
  line-height: 1.3em;
  margin-top: 15px;
  position: relative;
  text-align: left; }
  .erxes-staff-profile img {
    border-radius: 20px;
    float: left;
    height: 40px;
    overflow: hidden;
    width: 40px; }
  .erxes-staff-profile > div {
    margin-left: 50px; }

.erxes-state {
  background-color: #ddd;
  border-radius: 10px;
  display: inline-block;
  height: 8px;
  margin-bottom: 1px;
  width: 8px; }
  .erxes-state.online {
    background-color: #3ccc38; }

.erxes-topbar-title {
  align-self: center;
  font-weight: 600;
  line-height: 1.2em;
  overflow: hidden; }
  .erxes-topbar-title > div span {
    display: inline;
    opacity: .8; }
  .erxes-topbar-title span {
    display: block;
    font-size: 11px;
    font-weight: 300;
    margin-top: 3px;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 100%; }

[class*=" erxes-icon-"],
[class^=erxes-icon-] {
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  display: block;
  height: 32px;
  width: 32px; }

.erxes-icon-alarm {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/alarm.svg"); }

.erxes-icon-bar-chart {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/bar-chart.svg"); }

.erxes-icon-book {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/book.svg"); }

.erxes-icon-briefcase {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/briefcase.svg"); }

.erxes-icon-calculator {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/calculator.svg"); }

.erxes-icon-calendar {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/calendar.svg"); }

.erxes-icon-clipboard {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/clipboard.svg"); }

.erxes-icon-cloudcomputing {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/cloudcomputing.svg"); }

.erxes-icon-compass {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/compass.svg"); }

.erxes-icon-computer {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/computer.svg"); }

.erxes-icon-dashboard {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/dashboard.svg"); }

.erxes-icon-diagram {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/diagram.svg"); }

.erxes-icon-diamond {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/diamond.svg"); }

.erxes-icon-bar-earthgrid {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/bar-earthgrid.svg"); }

.erxes-icon-flag {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/flag.svg"); }

.erxes-icon-folder {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/folder.svg"); }

.erxes-icon-head-1 {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/head-1.svg"); }

.erxes-icon-home {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/home.svg"); }

.erxes-icon-idea {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/idea.svg"); }

.erxes-icon-laptop {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/laptop.svg"); }

.erxes-icon-like {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/like.svg"); }

.erxes-icon-medal {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/medal.svg"); }

.erxes-icon-megaphone {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/megaphone.svg"); }

.erxes-icon-paste {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/paste.svg"); }

.erxes-icon-piechart {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/piechart.svg"); }

.erxes-icon-piggybank {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/piggybank.svg"); }

.erxes-icon-puzzle {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/puzzle.svg"); }

.erxes-icon-scale {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/scale.svg"); }

.erxes-icon-settings {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/settings.svg"); }

.erxes-icon-star {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/star.svg"); }

.erxes-icon-tools {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/tools.svg"); }

.erxes-icon-umbrella {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/umbrella.svg"); }

.erxes-icon-paintpalette {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/paintpalette.svg"); }

.erxes-icon-users {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/users.svg"); }

.erxes-icon-stamp {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/stamp.svg"); }

.erxes-icon-phone-call {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/phone-call.svg"); }

.erxes-icon-magicwand {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/magicwand.svg"); }

.erxes-icon-folder {
  background-image: url("https://ui.app.salesmatch.ai/images/icons/icons/folder.svg"); }

.erxes-messenger-embed .head-wrapper {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  height: auto !important; }

.head-wrapper {
  background-color: var(--background, #fff);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  transition: height 0.25s ease-in-out;
  background-image: url("https://ui.app.salesmatch.ai/images/icons/pattern.png");
  background-repeat: repeat;
  background-size: cover; }
  @media screen and (max-width: 384px) {
    .head-wrapper {
      border: none;
      border-radius: 0; } }

.erxes-topbar {
  align-items: center;
  background: none;
  display: flex;
  justify-content: space-around;
  min-height: 70px;
  padding: 0;
  width: auto;
  z-index: 2; }
  .erxes-topbar.expanded {
    height: auto; }
    .erxes-topbar.expanded .erxes-topbar-title {
      margin-right: 55px; }
    .erxes-topbar.expanded .loader-wrapper {
      margin-left: -50px; }
  .erxes-topbar .erxes-middle {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex: 1;
    flex-shrink: 0;
    width: 100%;
    max-width: 100%;
    height: 100%;
    transition-property: background, opacity; }
  .erxes-topbar .welcome-info {
    display: flex;
    flex-direction: column;
    align-items: center; }
    .erxes-topbar .welcome-info h3 {
      font-size: 2.25rem;
      font-weight: 500;
      margin: 0;
      text-overflow: ellipsis;
      overflow: hidden; }
    .erxes-topbar .welcome-info .description {
      opacity: 0.8;
      font-size: 13px;
      line-height: 21px; }
  .erxes-topbar .socials a {
    margin-right: 12px;
    opacity: 0.6; }
    .erxes-topbar .socials a:hover {
      opacity: 1; }
    .erxes-topbar .socials a:last-of-type {
      margin-right: 0; }
  .erxes-topbar .socials img {
    height: 18px;
    width: 18px; }
  .erxes-topbar .erxes-topbar-title.limited {
    max-width: 260px; }
    .erxes-topbar .erxes-topbar-title.limited > div,
    .erxes-topbar .erxes-topbar-title.limited > span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap; }

.erxes-supporters {
  align-items: baseline;
  display: flex; }
  .erxes-supporters .erxes-supporter {
    flex: 1;
    flex-shrink: 0;
    margin-right: -8px; }
    .erxes-supporters .erxes-supporter:last-of-type {
      margin: 0; }
  .erxes-supporters .erxes-staff-name {
    opacity: 0.8;
    display: none;
    font-size: 12px;
    text-transform: capitalize; }
  .erxes-supporters.full {
    padding-top: 10px; }
    .erxes-supporters.full .erxes-supporter {
      margin: 0;
      padding: 0 5px; }
    .erxes-supporters.full .erxes-staff-name {
      display: block; }
    .erxes-supporters.full .avatar {
      display: inline-block; }
      .erxes-supporters.full .avatar img {
        border: 0; }
    .erxes-supporters.full .erxes-tooltip::before {
      display: none; }

.erxes-profile {
  text-align: left; }
  .erxes-profile .top-content {
    align-items: center;
    display: flex; }
    .erxes-profile .top-content .user-name {
      flex: 1;
      font-size: 13px;
      margin-left: 10px;
      max-width: 200px;
      overflow: hidden; }
    .erxes-profile .top-content span {
      opacity: 0.8;
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: .8em; }
    .erxes-profile .top-content h5 {
      font-size: 13px;
      margin: 0; }
  .erxes-profile .bottom-content {
    opacity: 0.8; }
    .erxes-profile .bottom-content p {
      font-size: 13px;
      margin-bottom: 0; }
    .erxes-profile .bottom-content img {
      margin-top: 10px; }

.avatar {
  position: relative; }
  .avatar img {
    background: rgba(0, 0, 0, 0.2);
    border: 2px solid transparent;
    border-radius: 22px;
    display: block;
    object-fit: cover;
    object-position: center;
    height: 40px;
    width: 40px; }
  .avatar .erxes-state {
    bottom: 2px;
    position: absolute;
    right: 2px;
    z-index: 2; }

.erxes-home-container {
  flex: 1;
  overflow: hidden;
  background: #fff;
  padding-top: 0 !important; }
  .erxes-home-container .integration-box {
    animation-delay: .4s;
    background: #fff;
    border-radius: 10px; }
  .erxes-home-container .empty-list {
    padding: 0 20px 20px; }
    .erxes-home-container .empty-list p {
      color: #888;
      margin-top: 0; }
  .erxes-home-container .head-wrapper .erxes-middle {
    justify-content: flex-start; }
  .erxes-home-container .erxes-home-content {
    overflow: auto;
    padding: 24px; }
    .erxes-home-container .erxes-home-content.tabbed {
      margin-top: 0; }
    .erxes-home-container .erxes-home-content .scroll-wrapper {
      height: calc(100% - 60px);
      overflow: auto; }

.erxes-welcome {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  overflow-wrap: break-word;
  text-align: left;
  word-wrap: break-word; }
  .erxes-welcome .erxes-supporters {
    padding-top: 10px; }
    .erxes-welcome .erxes-supporters .erxes-supporter {
      display: inline-block;
      flex: none;
      margin-right: 10px; }
    .erxes-welcome .erxes-supporters img {
      border: 0; }
  .erxes-welcome .erxes-topbar-title {
    display: none; }
  .erxes-welcome .erxes-tooltip::before {
    top: -100%; }
  .erxes-welcome .loader-wrapper {
    margin-left: -50px; }
  .erxes-welcome.tabbed {
    padding-bottom: 60px; }
  .erxes-welcome .assist-bar {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px; }
    .erxes-welcome .assist-bar time {
      opacity: 0.7;
      font-size: 11px; }
    .erxes-welcome .assist-bar .socials {
      margin-right: 30px; }
  .erxes-welcome .server-info {
    padding: 10px 0;
    font-size: 12px; }
    .erxes-welcome .server-info p {
      margin: 0; }

.erxes-tab {
  border-bottom: 1px solid #ddd;
  color: #000;
  cursor: pointer;
  display: flex;
  position: relative; }
  .erxes-tab .indicator {
    background: #ED3D07;
    bottom: -1px;
    height: 2px;
    left: 50%;
    position: absolute;
    transition: left .3s ease;
    width: 50%; }
    .erxes-tab .indicator.left {
      left: 0; }
  .erxes-tab > span {
    align-items: center;
    background: #fff;
    display: flex;
    flex: 1;
    font-size: 11px;
    justify-content: center;
    text-align: center;
    text-transform: uppercase;
    transition: all .3s ease; }
    .erxes-tab > span:last-of-type {
      border-left: 1px solid #ddd; }

.loader-wrapper {
  height: 70px;
  position: relative; }

.erxes-messenger {
  border-radius: 10px;
  bottom: 76px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  height: calc(100% - 70px);
  max-height: 720px;
  overflow: auto;
  position: absolute;
  right: 0;
  width: 100%;
  z-index: 2147483647;
  background-color: #fff; }
  .erxes-messenger.erxes-messenger-embed {
    position: static;
    right: initial;
    bottom: initial;
    z-index: initial;
    width: 100%;
    height: 100%;
    border: none;
    border-radius: 0; }
    .erxes-messenger.erxes-messenger-embed .erxes-message-sender {
      border-radius: 0; }
  .erxes-messenger > * {
    height: 100%; }
  .erxes-messenger > div.visible {
    display: flex;
    flex-direction: column;
    height: 100%;
    visibility: visible; }
  .erxes-messenger > div.hide {
    display: none;
    visibility: hidden; }
  @media screen and (max-width: 384px) {
    .erxes-messenger {
      border: none !important;
      border-radius: 0;
      bottom: 70px;
      height: calc(100% - 70px);
      max-height: none;
      right: 0;
      width: 100%; } }

.accquire-information {
  display: flex;
  flex-direction: column;
  justify-content: start;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1; }
  @media screen and (max-width: 384px) {
    .accquire-information {
      height: auto !important; } }
  .accquire-information .type {
    margin-top: 0; }
    .accquire-information .type span {
      cursor: pointer;
      display: inline-block;
      margin-right: 10px; }
      .accquire-information .type span.current {
        border-bottom: 1px solid;
        font-weight: bold; }
  .accquire-information .form {
    display: flex;
    flex-direction: row;
    flex-shrink: 0;
    flex-wrap: wrap;
    margin-top: 5px; }
    @media screen and (max-width: 384px) {
      .accquire-information .form {
        gap: 10px; } }
    .accquire-information .form.invalid {
      -webkit-animation-delay: 0;
      -webkit-animation-duration: 0.8s;
      -webkit-animation-name: shake;
      -webkit-animation-iteration-count: initial;
      -webkit-animation-timing-function: cubic-bezier(0.36, 0.07, 0.19, 0.97);
      -moz-animation-delay: 0;
      -moz-animation-duration: 0.8s;
      -moz-animation-name: shake;
      -moz-animation-iteration-count: initial;
      -moz-animation-timing-function: cubic-bezier(0.36, 0.07, 0.19, 0.97);
      animation-delay: 0;
      animation-duration: 0.8s;
      animation-name: shake;
      animation-iteration-count: initial;
      animation-timing-function: cubic-bezier(0.36, 0.07, 0.19, 0.97); }
      .accquire-information .form.invalid input {
        border-color: #ea475d !important; }
    @media screen and (max-width: 384px) {
      .accquire-information .form .input-container,
      .accquire-information .form button {
        width: 100% !important; } }
    .accquire-information .form input {
      background: #faf9fb;
      border: 1px solid #ddd;
      border-bottom-left-radius: calc(\$border-radius / 2);
      border-top-left-radius: calc(\$border-radius / 2);
      box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.07);
      font-size: 14px; }
    .accquire-information .form input {
      -webkit-appearance: none;
      box-sizing: border-box;
      flex: 1;
      max-width: 15rem;
      height: 40px;
      margin-right: 0;
      outline: 0;
      padding: 10px 15px;
      width: 100%; }
      @media screen and (max-width: 384px) {
        .accquire-information .form input {
          font-size: 16px; } }
      @media screen and (min-width: 610px) {
        .accquire-information .form input {
          max-width: 300px; } }
    .accquire-information .form button {
      background-color: #ED3D07;
      border: 0;
      border-radius: 0;
      border-bottom-right-radius: calc(\$border-radius / 2);
      border-top-right-radius: calc(\$border-radius / 2);
      height: 40px;
      margin: 0;
      outline: 0;
      padding: 4px;
      position: relative;
      width: 40px; }
      .accquire-information .form button svg {
        margin-top: 3px; }
      .accquire-information .form button .loader {
        border: 2px solid rgba(255, 255, 255, 0.8);
        border-top: 2px solid rgba(255, 255, 255, 0.3);
        height: 16px;
        width: 16px; }
  @media screen and (max-width: 384px) {
    .accquire-information {
      height: 100%; } }

.websiteApp {
  height: 100%;
  border: none; }

.websiteApp-home {
  padding: 0px 20px 20px; }
  .websiteApp-home p {
    margin: 0px;
    padding: 0px;
    margin-bottom: 15px; }
  .websiteApp-home button:hover {
    box-shadow: 0 5px 20px 5px rgba(0, 0, 0, 0.1); }

#page-root #erxes-video-container {
  background: #fff;
  position: absolute;
  right: 0;
  top: -30px;
  bottom: 0;
  width: 100%;
  transition: all ease 0.2s; }
  #page-root #erxes-video-container .erxes-toggle-video {
    width: 42px;
    height: 28px;
    position: absolute;
    bottom: 76px;
    right: 5px;
    background-size: 100%;
    cursor: pointer;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}); }

#page-root.mini-video #erxes-video-container {
  width: 290px;
  height: 220px;
  right: 8px;
  overflow: hidden;
  box-shadow: 0 0 6px 1px rgba(0, 0, 0, 0.1);
  border-radius: 5px; }
  #page-root.mini-video #erxes-video-container .erxes-toggle-video {
    width: 26px;
    height: 26px;
    right: 8px;
    bottom: 10px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}); }
  #page-root.mini-video #erxes-video-container iframe {
    height: 286px; }

#page-root iframe#erxes-video-iframe {
  width: 100%;
  height: 100%;
  border: none;
  outline: 0; }

.erxes-conversation-detail {
  display: flex;
  flex: 1;
  flex-direction: column;
  max-height: 100%; }

.erxes-conversation-content {
  display: flex;
  flex: 1;
  position: relative; }
  .erxes-conversation-content .erxes-content-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%; }

.erxes-conversation-list {
  list-style: none;
  margin: 0;
  padding: 0;
  margin-bottom: 70px; }

.erxes-conversation-init {
  list-style: none;
  margin: 0;
  padding: 0; }

.erxes-last-section {
  list-style: none;
  position: fixed;
  bottom: 76px;
  background: #fff;
  border-top: 1px solid #eaebed;
  width: 76.7%;
  margin: 0px;
  padding: 12px;
  left: 42px; }
  .erxes-last-section > .erxes-create-btn {
    background: #e73049;
    cursor: pointer;
    display: grid;
    grid-template-columns: 20% 80%;
    justify-items: center;
    align-items: center;
    color: #fff;
    border-radius: 5px; }
    .erxes-last-section > .erxes-create-btn > .erxes-start-text {
      padding-bottom: 5px; }

.erxes-list-item {
  -webkit-transition: background 0.3s ease-in-out;
  -moz-transition: background 0.3s ease-in-out;
  -ms-transition: background 0.3s ease-in-out;
  -o-transition: background 0.3s ease-in-out;
  transition: background 0.3s ease-in-out;
  overflow: hidden;
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 10px;
  position: relative; }
  .erxes-list-item:hover {
    cursor: pointer; }
  .erxes-list-item.unread .erxes-last-message {
    color: #333333;
    font-weight: bold; }
  .erxes-list-item img.erxes-left-side {
    width: 40px;
    height: 40px; }
  .erxes-list-item .erxes-left-side {
    border-radius: 25px;
    text-align: center; }
    .erxes-list-item .erxes-left-side > span {
      align-items: center;
      background: rgba(0, 0, 0, 0.04);
      border: 1px solid #ddd;
      border-radius: 21px;
      box-sizing: border-box;
      display: flex;
      height: 42px;
      justify-content: center;
      width: 42px; }
    .erxes-list-item .erxes-left-side svg {
      stroke: #888; }
  .erxes-list-item:last-child .erxes-right-side {
    border: none; }
  .erxes-list-item .erxes-right-side {
    border-bottom: 1px solid #eaebed;
    padding: 20px 20px 20px 0;
    width: 100%; }
  .erxes-list-item .erxes-right-plus {
    border-bottom: 1px solid #eaebed;
    padding: 10px 10px 10px 0;
    width: 100%; }
  .erxes-list-item .erxes-name {
    font-weight: 400; }
    .erxes-list-item .erxes-name > span {
      color: #888; }
    .erxes-list-item .erxes-name > input {
      padding: 10px 10px;
      line-height: 1.4;
      border-radius: 5px;
      display: block;
      width: -webkit-fill-available;
      outline: none;
      border: 1px solid #ccc; }
  .erxes-list-item .erxes-last-message {
    color: #686868;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; }
  .erxes-list-item .erxes-date {
    color: #888;
    float: right;
    font-size: 12px;
    margin-top: 2px; }
    .erxes-list-item .erxes-date.erxes-tooltip::before {
      right: 0; }

.erxes-messages-list {
  list-style: none;
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start; }
  .erxes-messages-list li {
    margin-bottom: 10px;
    position: relative; }
    .erxes-messages-list li.from-customer .erxes-tooltip::before {
      right: 0; }
    .erxes-messages-list li .date {
      color: #686868;
      font-size: 11px;
      margin-left: 50px; }

.erxes-messages-background {
  background-color: #faf9fb;
  display: flex;
  flex: 1;
  flex-direction: column; }
  .erxes-messages-background.bg-1 {
    background-repeat: repeat;
    background-position: 0 0;
    background-image: url("https://ui.app.salesmatch.ai/images/icons/bg-1.png"); }
  .erxes-messages-background.bg-2 {
    background-repeat: repeat;
    background-position: 0 0;
    background-image: url("https://ui.app.salesmatch.ai/images/icons/bg-2.png"); }
  .erxes-messages-background.bg-3 {
    background-repeat: repeat;
    background-position: 0 0;
    background-image: url("https://ui.app.salesmatch.ai/images/icons/bg-3.png"); }
  .erxes-messages-background.bg-4 {
    background-repeat: repeat;
    background-position: 0 0;
    background-image: url("https://ui.app.salesmatch.ai/images/icons/bg-4.png"); }

.erxes-spacial-message {
  color: #686868;
  margin-bottom: 15px; }
  .erxes-spacial-message.right {
    line-height: normal;
    text-align: right;
    color: #888;
    margin-bottom: 15px; }
  .erxes-spacial-message.away {
    margin-bottom: 0;
    margin-top: 15px; }
  .erxes-spacial-message.ml50 {
    margin-left: 50px; }
  .erxes-spacial-message.with-background {
    background-color: #eaebed;
    border-radius: 10px;
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.2);
    padding: 20px; }
  .erxes-spacial-message ~ .erxes-spacial-message {
    margin-top: 15px; }

.erxes-message {
  background-color: #eaebed;
  border-radius: var(--radius);
  border-bottom-left-radius: 0;
  color: #686868;
  display: inline-block;
  margin: 0 20px 5px 50px;
  padding: 10px;
  position: relative;
  text-align: left;
  word-break: break-word; }
  .erxes-message.top {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: var(--radius); }
  .erxes-message.from-customer {
    background-color: #ED3D07;
    border-bottom-left-radius: var(--radius);
    border-bottom-right-radius: 0;
    color: #fff;
    margin: 0 0 5px 20px; }
    .erxes-message.from-customer a {
      color: #fff; }
    .erxes-message.from-customer.gray {
      background-color: #eaebed;
      color: #686868;
      margin-bottom: 0; }
  .erxes-message.attachment {
    background: #fff !important;
    border: 0; }
    .erxes-message.attachment > span {
      display: none; }
  .erxes-message p {
    margin-top: 0;
    word-break: break-word;
    margin-bottom: 10px; }
    .erxes-message p:last-child {
      margin-bottom: 0; }
  .erxes-message img {
    max-width: 240px; }
  .erxes-message ul {
    list-style-type: disc;
    padding-left: 20px; }
    .erxes-message ul li {
      margin-bottom: 5px;
      overflow: visible; }
  .erxes-message ol {
    list-style-type: decimal;
    padding-left: 20px; }
    .erxes-message ol li {
      margin-bottom: 5px;
      overflow: visible; }
  .erxes-message h3 {
    font-size: 16px;
    margin-bottom: 8px;
    margin-top: 0; }
  .erxes-message blockquote {
    border-left: 5px solid #ddd;
    font-size: 16px;
    margin: 0;
    padding: calc(\$core-spacing / 2) 20px; }
  .erxes-message pre {
    background-color: #eaebed;
    border: 1px solid #ddd;
    border-radius: 10px;
    color: #4d4d4d;
    display: block;
    font-size: 13px;
    line-height: 1.42857143;
    margin: 0;
    padding: 9.5px;
    word-break: break-all;
    word-wrap: break-word; }
  .erxes-message a {
    color: #ED3D07;
    outline: 0; }

.file-wrapper {
  color: #686868;
  overflow: hidden;
  padding-left: 30px;
  position: relative; }
  .file-wrapper svg {
    height: 20px;
    left: 0;
    position: absolute;
    top: 0;
    width: 16px; }
  .file-wrapper span {
    direction: rtl;
    display: block;
    max-width: 150px;
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap; }
  .file-wrapper:hover {
    color: #4f4f4f; }

.download-attachment {
  display: block;
  text-decoration: none; }
  .download-attachment img {
    -webkit-transition: opacity 0.3s ease-in-out;
    -moz-transition: opacity 0.3s ease-in-out;
    -ms-transition: opacity 0.3s ease-in-out;
    -o-transition: opacity 0.3s ease-in-out;
    transition: opacity 0.3s ease-in-out; }
    .download-attachment img:hover {
      opacity: 0.8; }

.erxes-avatar {
  width: 40px;
  height: 40px;
  position: absolute;
  bottom: 20px;
  left: 0; }
  .erxes-avatar,
  .erxes-avatar img {
    border-radius: 50%; }
  .erxes-avatar img {
    width: 100%;
    height: 100%; }
  .erxes-avatar.top {
    top: 0; }

.btn-resend {
  background: #fff;
  border: 0;
  border-radius: 10px;
  color: #686868;
  cursor: pointer;
  margin-top: 5px;
  outline: 0;
  padding: 5px 15px; }
  .btn-resend:focus, .btn-resend:hover {
    background: white; }

.app-message-box {
  background: #fff;
  border-radius: 10px;
  border-top: 3px solid #3b85f4;
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.15);
  color: #3a3a3a;
  margin-bottom: 8px;
  padding: 0; }
  .app-message-box.call-request {
    margin-bottom: 20px;
    padding: 16px; }
    .app-message-box.call-request h5 {
      margin: 0 0 5px 0;
      font-size: 15px;
      font-weight: 700; }
    .app-message-box.call-request .call-buttons {
      display: flex; }
      .app-message-box.call-request .call-buttons button {
        flex: 1;
        padding: 8px 16px;
        font-size: 13px;
        display: flex;
        align-items: center;
        justify-content: center; }
        .app-message-box.call-request .call-buttons button:last-child {
          margin-left: 10px; }
        .app-message-box.call-request .call-buttons button:hover {
          opacity: 0.9; }
        .app-message-box.call-request .call-buttons button span {
          margin-left: 5px; }
        .app-message-box.call-request .call-buttons button svg {
          fill: #fff; }
    .app-message-box.call-request p {
      margin: 0 0 15px; }
  .app-message-box.spaced {
    margin-left: 50px; }
  .app-message-box.flexible {
    display: inline-block; }
  .app-message-box .user-info {
    align-items: center;
    display: flex;
    flex-direction: column;
    padding: 20px;
    text-align: center; }
    .app-message-box .user-info h2 {
      font-size: 18px;
      margin: 20px 0 0; }
      .app-message-box .user-info h2 > span {
        font-size: 24px; }
    .app-message-box .user-info h4 {
      font-size: 14px;
      margin: 0 0 -10px;
      font-weight: 500;
      text-align: center; }
    .app-message-box .user-info img {
      background: #63d2d6;
      border: 1px solid #eee;
      border-radius: 60px;
      font-size: 20px;
      height: 60px;
      line-height: 60px;
      overflow: hidden;
      width: 60px; }
    .app-message-box .user-info strong {
      font-weight: 500; }
    .app-message-box .user-info.horizontal {
      flex-direction: row; }
      .app-message-box .user-info.horizontal strong {
        margin-left: 5px; }
  .app-message-box .call-button {
    border-top: 1px solid #ddd;
    padding: 20px;
    text-align: center; }
    .app-message-box .call-button h3 {
      margin-bottom: 15px;
      margin-top: 0;
      text-align: center; }
    .app-message-box .call-button button,
    .app-message-box .call-button > a {
      background: #3b85f4;
      border: 1px solid transparent;
      border-color: #3b85f4;
      border-radius: 5px;
      box-shadow: none;
      color: #fff;
      cursor: pointer;
      font-size: 14px;
      padding: 10px 20px;
      text-transform: initial;
      transition: all 0.3s ease;
      width: 100%; }
      .app-message-box .call-button button:hover,
      .app-message-box .call-button > a:hover {
        box-shadow: 0 2px 10px 0 #3b85f4; }
      .app-message-box .call-button button:focus,
      .app-message-box .call-button > a:focus {
        outline: 0; }
    .app-message-box .call-button > a {
      text-decoration: none;
      display: block;
      width: auto;
      text-align: center; }
    .app-message-box .call-button .join-call {
      margin-top: 10px;
      font-size: 12px;
      text-transform: lowercase;
      color: #888; }

.erxes-content {
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: auto;
  background: #fff; }
  .erxes-content .erxes-article-content {
    background: #faf9fb;
    color: #494949;
    height: 100%;
    padding: 30px; }
    .erxes-content .erxes-article-content h2 {
      margin-top: 0; }
    .erxes-content .erxes-article-content .date {
      color: #686868;
      font-size: 90%;
      margin-bottom: 10px; }
    .erxes-content .erxes-article-content p {
      margin-bottom: 10px; }
    .erxes-content .erxes-article-content iframe,
    .erxes-content .erxes-article-content img {
      max-width: 100%;
      height: auto; }
  .erxes-content .scroll-wrapper {
    flex: 1;
    overflow: auto; }

.faq-item {
  background: #fff; }
  .faq-item .erxes-right-side {
    margin-left: 80px; }
  .faq-item .erxes-left-side {
    border-radius: 0;
    margin-right: 10px;
    background: #f7f6f9;
    border-radius: 30px; }
    .faq-item .erxes-left-side i {
      height: 36px;
      margin: auto;
      margin-top: 3px;
      opacity: 0.7;
      width: 28px; }
  .faq-item .description {
    color: #686868;
    min-height: 20px; }

.back-category-button {
  display: flex;
  align-items: center;
  width: 100%;
  border: 0;
  outline: 0;
  border-bottom: 1px solid #ddd;
  background: #f7f6f9;
  text-transform: uppercase;
  font-size: 11px;
  cursor: pointer;
  transition: all ease 0.3s; }
  .back-category-button:hover {
    opacity: 0.8; }
  .back-category-button > svg {
    margin-right: 10px; }

.erxes-faq-searchbar {
  background: #f7f6f9;
  border-bottom: 1px solid #ddd;
  padding: 10px 25px;
  position: relative; }
  .erxes-faq-searchbar > input {
    background: #fff;
    margin: 0;
    padding-right: 40px; }
  .erxes-faq-searchbar > svg {
    fill: #888;
    position: absolute;
    right: 40px;
    top: 20px;
    width: 16px; }

.empty-articles {
  align-items: center;
  color: #686868;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center; }
  .empty-articles svg {
    fill: #686868;
    margin-bottom: 10px; }

.erxes-form {
  font-size: 14px;
  margin: 0;
  overflow: hidden; }
  .erxes-form .erxes-form-content {
    list-style: none;
    margin: 0;
    position: relative; }
    .erxes-form .erxes-form-content .erxes-description {
      color: #5c5c5c;
      margin-bottom: 10px; }
  .erxes-form .erxes-result {
    color: #686868; }
    .erxes-form .erxes-result p {
      margin: 0; }
  .erxes-form .react-datepicker__input-container {
    display: block; }

.react-datepicker-wrapper {
  display: block; }

.react-datepicker {
  border-color: #ddd !important;
  box-shadow: 0 5px 15px -3px rgba(0, 0, 0, 0.15); }
  .react-datepicker .react-datepicker__day--selected,
  .react-datepicker .react-datepicker__day--keyboard-selected {
    background-color: #ED3D07;
    border-radius: calc(\$border-radius / 2); }
    .react-datepicker .react-datepicker__day--selected:hover,
    .react-datepicker .react-datepicker__day--keyboard-selected:hover {
      background-color: #bb3006; }
  .react-datepicker .react-datepicker__header {
    background: #faf9fb;
    border-color: #ddd; }
    .react-datepicker .react-datepicker__header .react-datepicker__current-month,
    .react-datepicker .react-datepicker__header .react-datepicker-time__header {
      font-weight: 500; }
  .react-datepicker .react-datepicker__triangle {
    border-bottom-color: #faf9fb !important; }
    .react-datepicker .react-datepicker__triangle::before {
      border-bottom-color: #ddd !important; }

.custom-select {
  display: inline-block;
  position: relative;
  font-size: 16px;
  font-family: "Poppins", Helvetica, Arial, sans-serif;
  width: 200px; }

.custom-select select {
  display: none;
  /* Hide the default select element */ }

/* Style for the visible part of the select */
.custom-select .select-display {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border: 1px solid #ccc;
  cursor: pointer; }

/* Style for the dropdown options */
.custom-select .select-options {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  border: 1px solid #ccc;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background-color: #fff; }

.custom-select .select-option {
  padding: 10px;
  cursor: pointer; }

/* Show the options when the select is open */
.custom-select.open .select-options {
  display: block; }

.livekitcalls-container {
  display: flex;
  flex: 1;
  flex-direction: column;
  max-height: 100%; }

.livekitcalls-content {
  flex: 1 1 auto; }

.call-container {
  width: 100%;
  height: 100%; }

.phone-input-wrapper {
  display: flex; }

.country-select {
  background: transparent; }

.erxes-messenger-embed .erxes-message-sender {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0; }

.erxes-message-sender {
  border-top: 1px solid #f1f1f1;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1);
  font-size: 12px;
  min-height: 61px;
  overflow: auto;
  position: relative;
  max-height: 50%;
  border-bottom-right-radius: 25px;
  border-bottom-left-radius: 10px; }
  .erxes-message-sender textarea {
    -webkit-box-sizing: border-box !important;
    -moz-box-sizing: border-box !important;
    -ms-box-sizing: border-box !important;
    -o-box-sizing: border-box !important;
    box-sizing: border-box !important;
    border: 0;
    color: #686868;
    font-size: 14px;
    height: 100%;
    height: calc(100% - 1px);
    left: 0;
    line-height: 20px;
    max-width: 100%;
    outline: none;
    padding: 20px 25px;
    padding-right: 80px;
    position: absolute;
    resize: none;
    top: 0;
    width: 100%;
    overflow: hidden; }
    .erxes-message-sender textarea:focus {
      -webkit-box-shadow: none !important;
      -moz-box-shadow: none !important;
      -ms-box-shadow: none !important;
      -o-box-shadow: none !important;
      box-shadow: none !important; }
  .erxes-message-sender .ctrl {
    position: absolute;
    right: 15px;
    top: 13px; }
    .erxes-message-sender .ctrl .ctrl-item {
      float: left;
      width: 35px;
      height: 35px;
      line-height: 35px;
      margin: 0;
      cursor: pointer;
      opacity: 0.7;
      text-align: center;
      font-size: 14px; }
      .erxes-message-sender .ctrl .ctrl-item:hover {
        opacity: 1; }
      .erxes-message-sender .ctrl .ctrl-item svg {
        height: 36px; }
      .erxes-message-sender .ctrl .ctrl-item input[type='file'] {
        display: none; }
  .erxes-message-sender .loader {
    margin: 0;
    right: 20px;
    top: 17px; }

.erxes-notification {
  background: #faf9fb;
  border-color: transparent;
  border-radius: 10px;
  border-style: solid;
  border-width: 1px;
  bottom: 83px;
  box-shadow: 0 2px 15px 2px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  display: flex;
  max-width: 100%;
  position: absolute;
  right: 8px;
  width: 330px;
  z-index: 9998; }
  .erxes-notification > button {
    position: absolute;
    right: 0; }
  .erxes-notification.full-message {
    height: calc(100% - 110px); }
  .erxes-notification .close-notification {
    background: #d5d5d5;
    border-radius: 50%;
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.1);
    height: 22px;
    opacity: 1;
    position: absolute;
    right: 10px;
    text-align: center;
    top: 10px;
    transition: all .3s ease;
    width: 22px; }
    .erxes-notification .close-notification:hover {
      background: #bbbbbb; }
    .erxes-notification .close-notification svg {
      height: 22px;
      width: 14px; }
  .erxes-notification .flex-notification {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    width: 100%;
    max-height: 100%; }
  .erxes-notification .flex-notification-container {
    width: 100%; }
  .erxes-notification:hover {
    box-shadow: 0 2px 15px 2px rgba(0, 0, 0, 0.25);
    cursor: pointer; }
    .erxes-notification:hover .close-notification {
      opacity: 1; }
  .erxes-notification .notification-body {
    -webkit-box-orient: vertical;
    color: #686868;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-height: 22px;
    margin-bottom: 20px;
    overflow: hidden;
    padding: 0 20px;
    word-wrap: break-word; }
    .erxes-notification .notification-body.full-message {
      display: block;
      flex: 1;
      margin-bottom: 0;
      overflow: auto;
      padding: 0 20px 20px; }
    .erxes-notification .notification-body img {
      max-width: 100%; }
  .erxes-notification .user-info {
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-shrink: 0;
    padding: 20px 20px calc(\$core-spacing / 2); }
    .erxes-notification .user-info .erxes-avatar {
      margin-right: 10px;
      position: initial; }

.bot-message {
  margin: 0 20px 5px 50px;
  max-width: 100%; }
  .bot-message img {
    max-width: 100%;
    display: inherit; }
  .bot-message .image-message {
    border-radius: 8px;
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2); }

.cards-wrapper {
  position: relative; }
  .cards-wrapper .cards-navigation {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    pointer-events: none; }
    .cards-wrapper .cards-navigation .arrow {
      margin-bottom: 60px;
      width: 36px;
      height: 36px;
      display: flex;
      border-radius: 100%;
      box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.35);
      align-items: center;
      justify-content: center;
      transition: all .3s;
      cursor: pointer;
      background: #fff;
      pointer-events: all;
      z-index: 2; }
      .cards-wrapper .cards-navigation .arrow.next {
        margin-left: auto;
        margin-right: 8px; }
      .cards-wrapper .cards-navigation .arrow.prev {
        margin-left: -18px; }

.cards {
  display: flex;
  align-items: flex-start;
  transition: transform .3s; }

.card-item {
  flex-shrink: 0;
  margin-right: 15px;
  width: 240px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #dbe1e8;
  overflow: hidden;
  opacity: 0.7;
  transition: opacity .3s;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.1);
  user-select: none; }
  .card-item.active {
    opacity: 1; }
  .card-item .card-content {
    padding: 8px 16px 16px 16px; }
    .card-item .card-content p {
      color: #686868; }
  .card-item h4, .card-item p {
    margin-top: 8px;
    margin-bottom: 0; }
  .card-item .card-actions {
    margin-bottom: 1px; }
    .card-item .card-actions .card-action {
      padding: 8px 16px;
      border-top: 1px solid #dbe1e8;
      display: block;
      text-align: center;
      font-weight: 500; }
      .card-item .card-actions .card-action:hover {
        background: #faf9fb;
        cursor: pointer; }

.quick-replies {
  display: flex;
  flex-wrap: wrap;
  margin-left: -4px; }
  .quick-replies .reply-button {
    padding: 5px 15px;
    border: 1px solid #673fbd;
    margin: 4px;
    border-radius: 20px;
    font-weight: 500;
    color: #333; }
    .quick-replies .reply-button:hover {
      opacity: 0.8;
      cursor: pointer; }

.bot-indicator {
  display: inline-block;
  margin-bottom: 1px; }
  .bot-indicator span {
    height: 6px;
    width: 6px;
    float: left;
    margin: 0 2px;
    background-color: #555;
    display: block;
    border-radius: 50%;
    animation-name: wave;
    animation-duration: 1.3s;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite; }
  .bot-indicator span:nth-of-type(1) {
    animation-delay: 0.2s; }
  .bot-indicator span:nth-of-type(2) {
    animation-delay: 0.3s; }
  .bot-indicator span:nth-of-type(3) {
    animation-delay: 0.4s; }

@keyframes wave {
  0% {
    transform: translateY(0px); }
  28% {
    transform: translateY(-5px); }
  44% {
    transform: translateY(0px); } }

.skill-content {
  transition: transform .3s;
  margin: -5px 0;
  text-align: right; }

.skill-card {
  margin: 5px 0;
  border: 1px solid rgba(0, 0, 0, 0.03);
  display: inline-block;
  text-align: center;
  line-height: 18px;
  white-space: nowrap;
  font-size: 14px;
  border-radius: 20px;
  box-shadow: 0 1px 5px 1px rgba(0, 0, 0, 0.1); }
  .skill-card:hover {
    cursor: pointer;
    box-shadow: 0 1px 10px 2px rgba(0, 0, 0, 0.15);
    opacity: 0.9; }

.erxes-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2147483647; }

.erxes-modal {
  position: absolute;
  border: none;
  background: white;
  overflow: auto;
  border-radius: 8px;
  outline: none;
  padding: 20px;
  width: 260px;
  left: 50%;
  top: 80px;
  transform: translateX(-50%);
  outline: 0;
  max-width: 100%;
  animation-delay: 0s;
  animation-duration: .1s;
  box-shadow: rgba(66, 66, 66, 0.3) 0px 3px 60px 0px; }
  .erxes-modal h5 {
    margin: 0 0 18px;
    font-weight: 500; }
  .erxes-modal .modal-footer {
    display: flex;
    justify-content: flex-end; }
    .erxes-modal .modal-footer .erxes-button {
      margin-left: 8px;
      padding: 8px 16px; }
`, "",{"version":3,"sources":["webpack://./client/messenger/sass/style.scss"],"names":[],"mappings":"AACA;EACE,UAAU,EAAE;;AAEd;EACE,YAAY;EACZ,UAAU;EACV,gCAAgC,EAAE;;AAEpC;EACE,YAAY,EAAE;;AAEhB;EACE,UAAU,EAAE;;AAEd;EACE,SAAS;EACT,UAAU;EACV,gCAAgC,EAAE;;AAEpC;EACE,UAAU,EAAE;;AAEd;EACE,UAAU;EACV,2BAA2B,EAAE;;AAE/B;EACE,UAAU;EACV,wBAAwB;EACxB,0DAA0D,EAAE;;AAE9D;EACE,UAAU;EACV,wBAAwB;EACxB,0DAA0D,EAAE;;AAE9D;EACE,UAAU;EACV,4BAA4B,EAAE;;AAEhC;EACE,UAAU,EAAE;;AAEd;;EAEE,WAAW;EACX,2BAA2B,EAAE;;AAE/B;;EAEE,UAAU;EACV,wBAAwB;EACxB,0DAA0D,EAAE;;AAE9D;;EAEE,aAAa,EAAE;;AAEjB;;EAEE,UAAU;EACV,2BAA2B,EAAE;;AAE/B;;EAEE,UAAU;EACV,wBAAwB;EACxB,gEAAgE,EAAE;;AAEpE;;EAEE,UAAU;EACV,2BAA2B;EAC3B,0DAA0D,EAAE;;AAE9D;EACE,cAAc,EAAE;;AAElB;EACE,aAAa,EAAE;;AAEjB;;EAEE,UAAU;EACV,qBAAqB;EACrB,2BAA2B,EAAE;;AAE/B;;EAEE,UAAU;EACV,mBAAmB;EACnB,2BAA2B;EAC3B,8DAA8D;EAC9D,uCAAuC,EAAE;;AAE3C;EACE,UAAU;EACV,mBAAmB,EAAE;;AAEvB;EACE,UAAU;EACV,qBAAqB;EACrB,2BAA2B;EAC3B,yDAAyD;EACzD,uCAAuC,EAAE;;AAE3C;EACE,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,+DAA+D;EAC/D,wBAAwB;EACxB,+BAA+B,EAAE;;AAEnC;;;EAGE,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,kCAAkC,EAAE;;AAEtC;EACE,sBAAsB,EAAE;;AAE1B;EACE,2BAA2B,EAAE;;AAE/B;EACE,0BAA0B,EAAE;;AAE9B;EACE;IACE,mBAAmB;IACnB,WAAW,EAAE;EACf;IACE,qBAAqB;IACrB,UAAU,EAAE;EACd;IACE,qBAAqB;IACrB,UAAU,EAAE;EACd;IACE,mBAAmB;IACnB,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,mBAAmB;IACnB,WAAW,EAAE;EACf;IACE,qBAAqB;IACrB,UAAU,EAAE;EACd;IACE,qBAAqB;IACrB,UAAU,EAAE;EACd;IACE,mBAAmB;IACnB,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,mBAAmB;IACnB,WAAW,EAAE;EACf;IACE,qBAAqB;IACrB,UAAU,EAAE;EACd;IACE,qBAAqB;IACrB,UAAU,EAAE;EACd;IACE,mBAAmB;IACnB,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,uBAAuB,EAAE;EAC3B;IACE,yBAAyB,EAAE,EAAE;;AAEjC;EACE;IACE,uBAAuB,EAAE;EAC3B;IACE,yBAAyB,EAAE,EAAE;;AAEjC;EACE;IACE,uBAAuB,EAAE;EAC3B;IACE,yBAAyB,EAAE,EAAE;;AAEjC;EACE;IACE,kCAAkC,EAAE;EACtC;IACE,iCAAiC,EAAE;EACrC;IACE,kCAAkC,EAAE;EACtC;IACE,iCAAiC,EAAE,EAAE;;AAEzC;EACE;IACE,kCAAkC,EAAE;EACtC;IACE,iCAAiC,EAAE;EACrC;IACE,kCAAkC,EAAE;EACtC;IACE,iCAAiC,EAAE,EAAE;;AAEzC;EACE;IACE,kCAAkC,EAAE;EACtC;IACE,iCAAiC,EAAE;EACrC;IACE,kCAAkC,EAAE;EACtC;IACE,iCAAiC,EAAE,EAAE;;AAEzC;EACE;IACE,UAAU;IACV,qBAAqB;IACrB,yBAAyB,EAAE;EAC7B;IACE,UAAU;IACV,mBAAmB;IACnB,yBAAyB,EAAE,EAAE;;AAEjC;EACE;IACE,UAAU;IACV,qBAAqB;IACrB,yBAAyB,EAAE;EAC7B;IACE,UAAU;IACV,mBAAmB;IACnB,yBAAyB,EAAE,EAAE;;AAEjC;EACE;IACE,UAAU;IACV,qBAAqB;IACrB,yBAAyB,EAAE;EAC7B;IACE,UAAU;IACV,mBAAmB;IACnB,yBAAyB,EAAE,EAAE;;AAEjC;EACE;IACE,UAAU;IACV,2BAA2B,EAAE;EAC/B;IACE,UAAU;IACV,wBAAwB,EAAE,EAAE;;AAEhC;EACE;IACE,UAAU;IACV,2BAA2B,EAAE;EAC/B;IACE,UAAU;IACV,wBAAwB,EAAE,EAAE;;AAEhC;EACE;IACE,UAAU;IACV,2BAA2B,EAAE;EAC/B;IACE,UAAU;IACV,wBAAwB,EAAE,EAAE;;AAEhC;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU,EAAE,EAAE;;AAElB;EACE;IACE,UAAU;IACV,2BAA2B,EAAE;EAC/B;IACE,UAAU;IACV,eAAe,EAAE,EAAE;;AAEvB;EACE;IACE,UAAU;IACV,2BAA2B,EAAE;EAC/B;IACE,UAAU;IACV,eAAe,EAAE,EAAE;;AAEvB;EACE;IACE,UAAU;IACV,2BAA2B,EAAE;EAC/B;IACE,UAAU;IACV,eAAe,EAAE,EAAE;;AAEvB;EACE;IACE,UAAU;IACV,4BAA4B,EAAE;EAChC;IACE,UAAU;IACV,eAAe,EAAE,EAAE;;AAEvB;EACE;IACE,UAAU;IACV,4BAA4B,EAAE;EAChC;IACE,UAAU;IACV,eAAe,EAAE,EAAE;;AAEvB;EACE;IACE,UAAU;IACV,4BAA4B,EAAE;EAChC;IACE,UAAU;IACV,eAAe,EAAE,EAAE;;AAEvB;;;;EAIE,YAAY,EAAE;;AAEhB;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,oDAAoD;EACpD,SAAS,EAAE;;AAEb;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,kCAAkC;EAClC,mCAAmC;EACnC,gBAAgB;EAChB,SAAS,EAAE;EACX;;;IAGE,oDAAoD,EAAE;;AAE1D;EACE,YAAY,EAAE;EACd;IACE,UAAU,EAAE;EACd;IACE,aAAa;IACb,YAAY;IACZ,eAAe,EAAE;;AAErB;EACE,cAAc,EAAE;;AAElB;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,qCAAqC;EACrC,2CAA2C;EAC3C,yCAAyC;EACzC,uBAAuB;EACvB,2BAA2B;EAC3B,kCAAkC;EAClC,wCAAwC;EACxC,sCAAsC;EACtC,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;EAC7B,mCAAmC;EACnC,iCAAiC;EACjC,oCAAoC;EACpC,kBAAkB;EAClB,wCAAwC;EACxC,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW,EAAE;EACb;IACE,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,WAAW,EAAE;EACf;IACE,iBAAiB,EAAE;;AAEvB;EACE,kBAAkB,EAAE;EACpB;IACE,eAAe,EAAE;IACjB;MACE,UAAU;MACV,0BAA0B,EAAE;EAChC;IACE,gBAAgB;IAChB,mBAAmB;IACnB,+BAA+B;IAC/B,cAAc;IACd,2BAA2B;IAC3B,eAAe;IACf,UAAU;IACV,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;IAClB,uBAAuB;IACvB,SAAS;IACT,yBAAyB;IACzB,kGAAkG;IAClG,mBAAmB;IACnB,+BAA+B;IAC/B,UAAU,EAAE;EACd;IACE,WAAW,EAAE;;AAEjB;EACE,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;EACnC,gCAAgC;EAChC,mBAAmB;EACnB,SAAS;EACT,uCAAuC;EACvC,WAAW;EACX,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,kBAAkB,EAAE;EACpB;IACE,WAAW,EAAE;EACf;IACE,mBAAmB;IACnB,eAAe;IACf,qBAAqB,EAAE;EACzB;IACE,cAAc;IACd,WAAW,EAAE;EACf;IACE,mBAAmB;IACnB,YAAY,EAAE;EAChB;IACE,mBAAmB,EAAE;IACrB;MACE,mBAAmB,EAAE;EACzB;IACE,uBAAuB;IACvB,sBAAsB;IACtB,cAAc,EAAE;IAChB;MACE,uBAAuB;MACvB,YAAY,EAAE;EAClB;IACE,kBAAkB,EAAE;;AAExB;EACE,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;EACnC,gCAAgC;EAChC,mBAAmB;EACnB,SAAS;EACT,uCAAuC;EACvC,WAAW;EACX,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,kBAAkB,EAAE;EACpB;IACE,WAAW,EAAE;EACf;IACE,mBAAmB;IACnB,eAAe;IACf,qBAAqB,EAAE;EACzB;IACE,cAAc,EAAE;EAClB;IACE,mBAAmB;IACnB,YAAY,EAAE;EAChB;IACE,mBAAmB,EAAE;IACrB;MACE,mBAAmB,EAAE;EACzB;IACE,uBAAuB;IACvB,sBAAsB;IACtB,cAAc,EAAE;IAChB;MACE,uBAAuB;MACvB,YAAY,EAAE;;AAEpB;EACE,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;EACnC,gCAAgC;EAChC,mBAAmB;EACnB,SAAS;EACT,uCAAuC;EACvC,cAAc;EACd,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,kBAAkB,EAAE;EACpB;IACE,cAAc,EAAE;EAClB;IACE,mBAAmB;IACnB,eAAe;IACf,qBAAqB,EAAE;EACzB;IACE,cAAc,EAAE;EAClB;IACE,mBAAmB;IACnB,YAAY,EAAE;EAChB;IACE,mBAAmB,EAAE;IACrB;MACE,mBAAmB,EAAE;EACzB;IACE,uBAAuB;IACvB,sBAAsB;IACtB,cAAc,EAAE;IAChB;MACE,uBAAuB;MACvB,YAAY,EAAE;;AAEpB;EACE,mBAAmB,EAAE;EACrB;IACE,mBAAmB;IACnB,sBAAsB;IACtB,WAAW,EAAE;;AAEjB;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;EACnC,gCAAgC;EAChC,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,WAAW;EACX,aAAa,EAAE;EACf;IACE,YAAY;IACZ,YAAY,EAAE;EAChB;IACE,cAAc,EAAE;EAClB;IACE,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,4BAA4B,EAAE;EAChC;IACE,yBAAyB,EAAE;;AAE/B;;;;EAIE,gHAAgH;EAChH,oBAAoB;EACpB,wCAAwC,EAAE;;AAE5C;EACE,YAAY;EACZ,gBAAgB,EAAE;;AAEpB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,YAAY,EAAE;;AAEhB;EACE,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB,EAAE;EACpB;IACE,yBAAyB,EAAE;;AAE/B;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,WAAW;EACX,UAAU,EAAE;;AAEd;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,qBAAqB,EAAE;;AAEzB;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,iBAAiB,EAAE;;AAErB;EACE,aAAa,EAAE;;AAEjB;EACE,wBAAwB,EAAE;;AAE5B;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,YAAY;EACZ,SAAS;EACT,SAAS;EACT,6BAA6B,EAAE;EAC/B;IACE,UAAU;IACV,qBAAqB,EAAE;;AAE3B;EACE,eAAe,EAAE;;AAEnB;EACE,mBAAmB,EAAE;EACrB;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB;IAChB,eAAe,EAAE;IACjB;MACE,gBAAgB;MAChB,cAAc,EAAE;EACpB;IACE,cAAc;IACd,cAAc;IACd,eAAe,EAAE;IACjB;MACE,SAAS,EAAE;IACb;MACE,kBAAkB,EAAE;EACxB;IACE,eAAe,EAAE;EACnB;IACE,YAAY;IACZ,gBAAgB,EAAE;EACpB;IACE,cAAc;IACd,eAAe;IACf,gBAAgB,EAAE;;AAEtB;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,WAAW,EAAE;EACb;IACE,WAAW;IACX,kBAAkB;IAClB,cAAc,EAAE;;AAEpB;EACE,gBAAgB;EAChB,UAAU,EAAE;;AAEd;EACE,oCAAoC;EACpC,kBAAkB;EAClB,qEAAqE,EAAE;;AAEzE;EACE,+BAA+B,EAAE;;AAEnC;EACE,0DAA0D;EAC1D,yBAAyB;EACzB,wGAAwG;EACxG,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,yCAAyC;EACzC,cAAc;EACd,eAAe;EACf,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;EAC1B,QAAQ;EACR,kBAAkB;EAClB,SAAS;EACT,oEAAoE;EACpE,WAAW;EACX,mBAAmB,EAAE;EACrB;IACE,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW,EAAE;EACf;IACE,oEAA4T;IAC5T,gCAAgC;IAChC,wBAAwB;IACxB,oEAAoE,EAAE;IACtE;MACE,eAAe,EAAE;EACrB;IACE,6BAA6B;IAC7B,8BAA8B;IAC9B,sCAAsC;IACtC,qCAAqC;IACrC,yCAAyC;IACzC,0BAA0B;IAC1B,2BAA2B;IAC3B,mCAAmC;IACnC,kCAAkC;IAClC,sCAAsC;IACtC,qBAAqB;IACrB,sBAAsB;IACtB,8BAA8B;IAC9B,6BAA6B;IAC7B,iCAAiC;IACjC,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,WAAW,EAAE;EACf;IACE,YAAY;IACZ,aAAa,EAAE;;AAEnB;EACE,gBAAgB,EAAE;;AAEpB;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;EAC7B,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,WAAW,EAAE;EACb;IACE,WAAW;IACX,YAAY;IACZ,oBAAoB,EAAE;IACtB;MACE,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,UAAU,EAAE;EAChB;IACE,qBAAqB,EAAE;;AAE3B;EACE,+CAA+C;EAC/C,4CAA4C;EAC5C,2CAA2C;EAC3C,0CAA0C;EAC1C,uCAAuC;EACvC,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,cAAc;EACd,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,YAAY,EAAE;EACd;IACE,mBAAmB;IACnB,UAAU,EAAE;EACd;IACE,qDAAqD;IACrD,kDAAkD;IAClD,6CAA6C;IAC7C,wCAAwC;IACxC,qCAAqC;IACrC,oCAAoC;IACpC,mCAAmC;IACnC,gCAAgC;IAChC,+BAA+B;IAC/B,mBAAmB;IACnB,0BAA0B;IAC1B,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,UAAU,EAAE;IACZ;MACE,oBAAoB;MACpB,mBAAmB;MACnB,qBAAqB;MACrB,+BAA+B;MAC/B,cAAc,EAAE;MAChB;QACE,0BAA0B,EAAE;;AAEpC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB,EAAE;EAClB;IACE,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,WAAW,EAAE;EACf;IACE,iBAAiB,EAAE;;AAEvB;EACE,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,UAAU,EAAE;EACZ;IACE,yBAAyB,EAAE;;AAE/B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB,EAAE;EAClB;IACE,eAAe;IACf,WAAW,EAAE;EACf;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,eAAe,EAAE;;AAErB;;EAEE,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;EACxB,cAAc;EACd,YAAY;EACZ,WAAW,EAAE;;AAEf;EACE,kFAAkF,EAAE;;AAEtF;EACE,sFAAsF,EAAE;;AAE1F;EACE,iFAAiF,EAAE;;AAErF;EACE,sFAAsF,EAAE;;AAE1F;EACE,uFAAuF,EAAE;;AAE3F;EACE,qFAAqF,EAAE;;AAEzF;EACE,sFAAsF,EAAE;;AAE1F;EACE,2FAA2F,EAAE;;AAE/F;EACE,oFAAoF,EAAE;;AAExF;EACE,qFAAqF,EAAE;;AAEzF;EACE,sFAAsF,EAAE;;AAE1F;EACE,oFAAoF,EAAE;;AAExF;EACE,oFAAoF,EAAE;;AAExF;EACE,0FAA0F,EAAE;;AAE9F;EACE,iFAAiF,EAAE;;AAErF;EACE,mFAAmF,EAAE;;AAEvF;EACE,mFAAmF,EAAE;;AAEvF;EACE,iFAAiF,EAAE;;AAErF;EACE,iFAAiF,EAAE;;AAErF;EACE,mFAAmF,EAAE;;AAEvF;EACE,iFAAiF,EAAE;;AAErF;EACE,kFAAkF,EAAE;;AAEtF;EACE,sFAAsF,EAAE;;AAE1F;EACE,kFAAkF,EAAE;;AAEtF;EACE,qFAAqF,EAAE;;AAEzF;EACE,sFAAsF,EAAE;;AAE1F;EACE,mFAAmF,EAAE;;AAEvF;EACE,kFAAkF,EAAE;;AAEtF;EACE,qFAAqF,EAAE;;AAEzF;EACE,iFAAiF,EAAE;;AAErF;EACE,kFAAkF,EAAE;;AAEtF;EACE,qFAAqF,EAAE;;AAEzF;EACE,yFAAyF,EAAE;;AAE7F;EACE,kFAAkF,EAAE;;AAEtF;EACE,kFAAkF,EAAE;;AAEtF;EACE,uFAAuF,EAAE;;AAE3F;EACE,sFAAsF,EAAE;;AAE1F;EACE,mFAAmF,EAAE;;AAEvF;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB,EAAE;;AAE3B;EACE,yCAAyC;EACzC,4BAA4B;EAC5B,6BAA6B;EAC7B,oCAAoC;EACpC,8EAA8E;EAC9E,yBAAyB;EACzB,sBAAsB,EAAE;EACxB;IACE;MACE,YAAY;MACZ,gBAAgB,EAAE,EAAE;;AAE1B;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,UAAU,EAAE;EACZ;IACE,YAAY,EAAE;IACd;MACE,kBAAkB,EAAE;IACtB;MACE,kBAAkB,EAAE;EACxB;IACE,aAAa;IACb,uBAAuB;IACvB,2BAA2B;IAC3B,OAAO;IACP,cAAc;IACd,WAAW;IACX,eAAe;IACf,YAAY;IACZ,wCAAwC,EAAE;EAC5C;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAE;IACrB;MACE,kBAAkB;MAClB,gBAAgB;MAChB,SAAS;MACT,uBAAuB;MACvB,gBAAgB,EAAE;IACpB;MACE,YAAY;MACZ,eAAe;MACf,iBAAiB,EAAE;EACvB;IACE,kBAAkB;IAClB,YAAY,EAAE;IACd;MACE,UAAU,EAAE;IACd;MACE,eAAe,EAAE;EACrB;IACE,YAAY;IACZ,WAAW,EAAE;EACf;IACE,gBAAgB,EAAE;IAClB;;MAEE,gBAAgB;MAChB,uBAAuB;MACvB,mBAAmB,EAAE;;AAE3B;EACE,qBAAqB;EACrB,aAAa,EAAE;EACf;IACE,OAAO;IACP,cAAc;IACd,kBAAkB,EAAE;IACpB;MACE,SAAS,EAAE;EACf;IACE,YAAY;IACZ,aAAa;IACb,eAAe;IACf,0BAA0B,EAAE;EAC9B;IACE,iBAAiB,EAAE;IACnB;MACE,SAAS;MACT,cAAc,EAAE;IAClB;MACE,cAAc,EAAE;IAClB;MACE,qBAAqB,EAAE;MACvB;QACE,SAAS,EAAE;IACf;MACE,aAAa,EAAE;;AAErB;EACE,gBAAgB,EAAE;EAClB;IACE,mBAAmB;IACnB,aAAa,EAAE;IACf;MACE,OAAO;MACP,eAAe;MACf,iBAAiB;MACjB,gBAAgB;MAChB,gBAAgB,EAAE;IACpB;MACE,YAAY;MACZ,cAAc;MACd,gBAAgB;MAChB,uBAAuB;MACvB,mBAAmB;MACnB,eAAe,EAAE;IACnB;MACE,eAAe;MACf,SAAS,EAAE;EACf;IACE,YAAY,EAAE;IACd;MACE,eAAe;MACf,gBAAgB,EAAE;IACpB;MACE,gBAAgB,EAAE;;AAExB;EACE,kBAAkB,EAAE;EACpB;IACE,8BAA8B;IAC9B,6BAA6B;IAC7B,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,WAAW,EAAE;EACf;IACE,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,UAAU,EAAE;;AAEhB;EACE,OAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB,EAAE;EAC3B;IACE,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB,EAAE;EACvB;IACE,oBAAoB,EAAE;IACtB;MACE,WAAW;MACX,aAAa,EAAE;EACnB;IACE,2BAA2B,EAAE;EAC/B;IACE,cAAc;IACd,aAAa,EAAE;IACf;MACE,aAAa,EAAE;IACjB;MACE,yBAAyB;MACzB,cAAc,EAAE;;AAEtB;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB,EAAE;EACvB;IACE,iBAAiB,EAAE;IACnB;MACE,qBAAqB;MACrB,UAAU;MACV,kBAAkB,EAAE;IACtB;MACE,SAAS,EAAE;EACf;IACE,aAAa,EAAE;EACjB;IACE,UAAU,EAAE;EACd;IACE,kBAAkB,EAAE;EACtB;IACE,oBAAoB,EAAE;EACxB;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB,EAAE;IACrB;MACE,YAAY;MACZ,eAAe,EAAE;IACnB;MACE,kBAAkB,EAAE;EACxB;IACE,eAAe;IACf,eAAe,EAAE;IACjB;MACE,SAAS,EAAE;;AAEjB;EACE,6BAA6B;EAC7B,WAAW;EACX,eAAe;EACf,aAAa;EACb,kBAAkB,EAAE;EACpB;IACE,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,yBAAyB;IACzB,UAAU,EAAE;IACZ;MACE,OAAO,EAAE;EACb;IACE,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,OAAO;IACP,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,wBAAwB,EAAE;IAC1B;MACE,2BAA2B,EAAE;;AAEnC;EACE,YAAY;EACZ,kBAAkB,EAAE;;AAEtB;EACE,mBAAmB;EACnB,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,sBAAsB,EAAE;EACxB;IACE,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB,EAAE;IAClB;MACE,gBAAgB,EAAE;EACtB;IACE,YAAY,EAAE;EAChB;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,mBAAmB,EAAE;EACvB;IACE,aAAa;IACb,kBAAkB,EAAE;EACtB;IACE;MACE,uBAAuB;MACvB,gBAAgB;MAChB,YAAY;MACZ,yBAAyB;MACzB,gBAAgB;MAChB,QAAQ;MACR,WAAW,EAAE,EAAE;;AAErB;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,OAAO,EAAE;EACT;IACE;MACE,uBAAuB,EAAE,EAAE;EAC/B;IACE,aAAa,EAAE;IACf;MACE,eAAe;MACf,qBAAqB;MACrB,kBAAkB,EAAE;MACpB;QACE,wBAAwB;QACxB,iBAAiB,EAAE;EACzB;IACE,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,eAAe,EAAE;IACjB;MACE;QACE,SAAS,EAAE,EAAE;IACjB;MACE,0BAA0B;MAC1B,gCAAgC;MAChC,6BAA6B;MAC7B,0CAA0C;MAC1C,uEAAuE;MACvE,uBAAuB;MACvB,6BAA6B;MAC7B,0BAA0B;MAC1B,uCAAuC;MACvC,oEAAoE;MACpE,kBAAkB;MAClB,wBAAwB;MACxB,qBAAqB;MACrB,kCAAkC;MAClC,+DAA+D,EAAE;MACjE;QACE,gCAAgC,EAAE;IACtC;MACE;;QAEE,sBAAsB,EAAE,EAAE;IAC9B;MACE,mBAAmB;MACnB,sBAAsB;MACtB,mDAAmD;MACnD,gDAAgD;MAChD,iDAAiD;MACjD,eAAe,EAAE;IACnB;MACE,wBAAwB;MACxB,sBAAsB;MACtB,OAAO;MACP,gBAAgB;MAChB,YAAY;MACZ,eAAe;MACf,UAAU;MACV,kBAAkB;MAClB,WAAW,EAAE;MACb;QACE;UACE,eAAe,EAAE,EAAE;MACvB;QACE;UACE,gBAAgB,EAAE,EAAE;IAC1B;MACE,yBAAyB;MACzB,SAAS;MACT,gBAAgB;MAChB,oDAAoD;MACpD,iDAAiD;MACjD,YAAY;MACZ,SAAS;MACT,UAAU;MACV,YAAY;MACZ,kBAAkB;MAClB,WAAW,EAAE;MACb;QACE,eAAe,EAAE;MACnB;QACE,0CAA0C;QAC1C,8CAA8C;QAC9C,YAAY;QACZ,WAAW,EAAE;EACnB;IACE;MACE,YAAY,EAAE,EAAE;;AAEtB;EACE,YAAY;EACZ,YAAY,EAAE;;AAEhB;EACE,sBAAsB,EAAE;EACxB;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB,EAAE;EACvB;IACE,6CAA6C,EAAE;;AAEnD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,WAAW;EACX,yBAAyB,EAAE;EAC3B;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,qBAAqB;IACrB,eAAe;IACf,yDAA6wB,EAAE;;AAEnxB;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB,EAAE;EACpB;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,yDAAyxB,EAAE;EAC7xB;IACE,aAAa,EAAE;;AAEnB;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,UAAU,EAAE;;AAEd;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,gBAAgB,EAAE;;AAEpB;EACE,aAAa;EACb,OAAO;EACP,kBAAkB,EAAE;EACpB;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW,EAAE;;AAEjB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,mBAAmB,EAAE;;AAEvB;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU,EAAE;;AAEd;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ,WAAW;EACX,aAAa;EACb,UAAU,EAAE;EACZ;IACE,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,kBAAkB,EAAE;IACpB;MACE,mBAAmB,EAAE;;AAE3B;EACE,+CAA+C;EAC/C,4CAA4C;EAC5C,2CAA2C;EAC3C,0CAA0C;EAC1C,uCAAuC;EACvC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB,EAAE;EACpB;IACE,eAAe,EAAE;EACnB;IACE,cAAc;IACd,iBAAiB,EAAE;EACrB;IACE,WAAW;IACX,YAAY,EAAE;EAChB;IACE,mBAAmB;IACnB,kBAAkB,EAAE;IACpB;MACE,mBAAmB;MACnB,+BAA+B;MAC/B,sBAAsB;MACtB,mBAAmB;MACnB,sBAAsB;MACtB,aAAa;MACb,YAAY;MACZ,uBAAuB;MACvB,WAAW,EAAE;IACf;MACE,YAAY,EAAE;EAClB;IACE,YAAY,EAAE;EAChB;IACE,gCAAgC;IAChC,yBAAyB;IACzB,WAAW,EAAE;EACf;IACE,gCAAgC;IAChC,yBAAyB;IACzB,WAAW,EAAE;EACf;IACE,gBAAgB,EAAE;IAClB;MACE,WAAW,EAAE;IACf;MACE,kBAAkB;MAClB,gBAAgB;MAChB,kBAAkB;MAClB,cAAc;MACd,6BAA6B;MAC7B,aAAa;MACb,sBAAsB,EAAE;EAC5B;IACE,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB,EAAE;EACvB;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe,EAAE;IACjB;MACE,QAAQ,EAAE;;AAEhB;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,2BAA2B,EAAE;EAC7B;IACE,mBAAmB;IACnB,kBAAkB,EAAE;IACpB;MACE,QAAQ,EAAE;IACZ;MACE,cAAc;MACd,eAAe;MACf,iBAAiB,EAAE;;AAEzB;EACE,yBAAyB;EACzB,aAAa;EACb,OAAO;EACP,sBAAsB,EAAE;EACxB;IACE,yBAAyB;IACzB,wBAAwB;IACxB,2EAA2E,EAAE;EAC/E;IACE,yBAAyB;IACzB,wBAAwB;IACxB,2EAA2E,EAAE;EAC/E;IACE,yBAAyB;IACzB,wBAAwB;IACxB,2EAA2E,EAAE;EAC/E;IACE,yBAAyB;IACzB,wBAAwB;IACxB,2EAA2E,EAAE;;AAEjF;EACE,cAAc;EACd,mBAAmB,EAAE;EACrB;IACE,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,mBAAmB,EAAE;EACvB;IACE,gBAAgB;IAChB,gBAAgB,EAAE;EACpB;IACE,iBAAiB,EAAE;EACrB;IACE,yBAAyB;IACzB,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa,EAAE;EACjB;IACE,gBAAgB,EAAE;;AAEtB;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,4BAA4B;EAC5B,cAAc;EACd,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB,EAAE;EACxB;IACE,6BAA6B;IAC7B,wCAAwC,EAAE;EAC5C;IACE,yBAAyB;IACzB,wCAAwC;IACxC,6BAA6B;IAC7B,WAAW;IACX,oBAAoB,EAAE;IACtB;MACE,WAAW,EAAE;IACf;MACE,yBAAyB;MACzB,cAAc;MACd,gBAAgB,EAAE;EACtB;IACE,2BAA2B;IAC3B,SAAS,EAAE;IACX;MACE,aAAa,EAAE;EACnB;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAE;IACrB;MACE,gBAAgB,EAAE;EACtB;IACE,gBAAgB,EAAE;EACpB;IACE,qBAAqB;IACrB,kBAAkB,EAAE;IACpB;MACE,kBAAkB;MAClB,iBAAiB,EAAE;EACvB;IACE,wBAAwB;IACxB,kBAAkB,EAAE;IACpB;MACE,kBAAkB;MAClB,iBAAiB,EAAE;EACvB;IACE,eAAe;IACf,kBAAkB;IAClB,aAAa,EAAE;EACjB;IACE,2BAA2B;IAC3B,eAAe;IACf,SAAS;IACT,qCAAqC,EAAE;EACzC;IACE,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;IACd,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,cAAc;IACd,qBAAqB;IACrB,qBAAqB,EAAE;EACzB;IACE,cAAc;IACd,UAAU,EAAE;;AAEhB;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB,EAAE;EACpB;IACE,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,WAAW,EAAE;EACf;IACE,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB,EAAE;EACvB;IACE,cAAc,EAAE;;AAEpB;EACE,cAAc;EACd,qBAAqB,EAAE;EACvB;IACE,4CAA4C;IAC5C,yCAAyC;IACzC,wCAAwC;IACxC,uCAAuC;IACvC,oCAAoC,EAAE;IACtC;MACE,YAAY,EAAE;;AAEpB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,OAAO,EAAE;EACT;;IAEE,kBAAkB,EAAE;EACtB;IACE,WAAW;IACX,YAAY,EAAE;EAChB;IACE,MAAM,EAAE;;AAEZ;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;EACV,iBAAiB,EAAE;EACnB;IACE,iBAAiB,EAAE;;AAEvB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,4CAA4C;EAC5C,cAAc;EACd,kBAAkB;EAClB,UAAU,EAAE;EACZ;IACE,mBAAmB;IACnB,aAAa,EAAE;IACf;MACE,iBAAiB;MACjB,eAAe;MACf,gBAAgB,EAAE;IACpB;MACE,aAAa,EAAE;MACf;QACE,OAAO;QACP,iBAAiB;QACjB,eAAe;QACf,aAAa;QACb,mBAAmB;QACnB,uBAAuB,EAAE;QACzB;UACE,iBAAiB,EAAE;QACrB;UACE,YAAY,EAAE;QAChB;UACE,gBAAgB,EAAE;QACpB;UACE,UAAU,EAAE;IAClB;MACE,gBAAgB,EAAE;EACtB;IACE,iBAAiB,EAAE;EACrB;IACE,qBAAqB,EAAE;EACzB;IACE,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,kBAAkB,EAAE;IACpB;MACE,eAAe;MACf,gBAAgB,EAAE;MAClB;QACE,eAAe,EAAE;IACrB;MACE,eAAe;MACf,iBAAiB;MACjB,gBAAgB;MAChB,kBAAkB,EAAE;IACtB;MACE,mBAAmB;MACnB,sBAAsB;MACtB,mBAAmB;MACnB,eAAe;MACf,YAAY;MACZ,iBAAiB;MACjB,gBAAgB;MAChB,WAAW,EAAE;IACf;MACE,gBAAgB,EAAE;IACpB;MACE,mBAAmB,EAAE;MACrB;QACE,gBAAgB,EAAE;EACxB;IACE,0BAA0B;IAC1B,aAAa;IACb,kBAAkB,EAAE;IACpB;MACE,mBAAmB;MACnB,aAAa;MACb,kBAAkB,EAAE;IACtB;;MAEE,mBAAmB;MACnB,6BAA6B;MAC7B,qBAAqB;MACrB,kBAAkB;MAClB,gBAAgB;MAChB,WAAW;MACX,eAAe;MACf,eAAe;MACf,kBAAkB;MAClB,uBAAuB;MACvB,yBAAyB;MACzB,WAAW,EAAE;MACb;;QAEE,gCAAgC,EAAE;MACpC;;QAEE,UAAU,EAAE;IAChB;MACE,qBAAqB;MACrB,cAAc;MACd,WAAW;MACX,kBAAkB,EAAE;IACtB;MACE,gBAAgB;MAChB,eAAe;MACf,yBAAyB;MACzB,WAAW,EAAE;;AAEnB;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,cAAc;EACd,gBAAgB,EAAE;EAClB;IACE,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,aAAa,EAAE;IACf;MACE,aAAa,EAAE;IACjB;MACE,cAAc;MACd,cAAc;MACd,mBAAmB,EAAE;IACvB;MACE,mBAAmB,EAAE;IACvB;;MAEE,eAAe;MACf,YAAY,EAAE;EAClB;IACE,OAAO;IACP,cAAc,EAAE;;AAEpB;EACE,gBAAgB,EAAE;EAClB;IACE,iBAAiB,EAAE;EACrB;IACE,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB,EAAE;IACrB;MACE,YAAY;MACZ,YAAY;MACZ,eAAe;MACf,YAAY;MACZ,WAAW,EAAE;EACjB;IACE,cAAc;IACd,gBAAgB,EAAE;;AAEtB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,UAAU;EACV,6BAA6B;EAC7B,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,yBAAyB,EAAE;EAC3B;IACE,YAAY,EAAE;EAChB;IACE,kBAAkB,EAAE;;AAExB;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB,EAAE;EACpB;IACE,gBAAgB;IAChB,SAAS;IACT,mBAAmB,EAAE;EACvB;IACE,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW,EAAE;;AAEjB;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB,EAAE;EACzB;IACE,aAAa;IACb,mBAAmB,EAAE;;AAEzB;EACE,eAAe;EACf,SAAS;EACT,gBAAgB,EAAE;EAClB;IACE,gBAAgB;IAChB,SAAS;IACT,kBAAkB,EAAE;IACpB;MACE,cAAc;MACd,mBAAmB,EAAE;EACzB;IACE,cAAc,EAAE;IAChB;MACE,SAAS,EAAE;EACf;IACE,cAAc,EAAE;;AAEpB;EACE,cAAc,EAAE;;AAElB;EACE,6BAA6B;EAC7B,+CAA+C,EAAE;EACjD;;IAEE,yBAAyB;IACzB,uCAAuC,EAAE;IACzC;;MAEE,yBAAyB,EAAE;EAC/B;IACE,mBAAmB;IACnB,kBAAkB,EAAE;IACpB;;MAEE,gBAAgB,EAAE;EACtB;IACE,uCAAuC,EAAE;IACzC;MACE,oCAAoC,EAAE;;AAE5C;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,oDAAoD;EACpD,YAAY,EAAE;;AAEhB;EACE,aAAa;EACb,oCAAoC,EAAE;;AAExC,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,eAAe,EAAE;;AAEnB,mCAAmC;AACnC;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,sBAAsB;EACtB,wCAAwC;EACxC,sBAAsB,EAAE;;AAE1B;EACE,aAAa;EACb,eAAe,EAAE;;AAEnB,6CAA6C;AAC7C;EACE,cAAc,EAAE;;AAElB;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,gBAAgB,EAAE;;AAEpB;EACE,cAAc,EAAE;;AAElB;EACE,WAAW;EACX,YAAY,EAAE;;AAEhB;EACE,aAAa,EAAE;;AAEjB;EACE,uBAAuB,EAAE;;AAE3B;EACE,6BAA6B;EAC7B,4BAA4B,EAAE;;AAEhC;EACE,6BAA6B;EAC7B,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,+BAA+B,EAAE;EACjC;IACE,yCAAyC;IACzC,sCAAsC;IACtC,qCAAqC;IACrC,oCAAoC;IACpC,iCAAiC;IACjC,SAAS;IACT,cAAc;IACd,eAAe;IACf,YAAY;IACZ,wBAAwB;IACxB,OAAO;IACP,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,MAAM;IACN,WAAW;IACX,gBAAgB,EAAE;IAClB;MACE,mCAAmC;MACnC,gCAAgC;MAChC,+BAA+B;MAC/B,8BAA8B;MAC9B,2BAA2B,EAAE;EACjC;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS,EAAE;IACX;MACE,WAAW;MACX,WAAW;MACX,YAAY;MACZ,iBAAiB;MACjB,SAAS;MACT,eAAe;MACf,YAAY;MACZ,kBAAkB;MAClB,eAAe,EAAE;MACjB;QACE,UAAU,EAAE;MACd;QACE,YAAY,EAAE;MAChB;QACE,aAAa,EAAE;EACrB;IACE,SAAS;IACT,WAAW;IACX,SAAS,EAAE;;AAEf;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,6CAA6C;EAC7C,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa,EAAE;EACf;IACE,kBAAkB;IAClB,QAAQ,EAAE;EACZ;IACE,0BAA0B,EAAE;EAC9B;IACE,mBAAmB;IACnB,kBAAkB;IAClB,0CAA0C;IAC1C,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,wBAAwB;IACxB,WAAW,EAAE;IACb;MACE,mBAAmB,EAAE;IACvB;MACE,YAAY;MACZ,WAAW,EAAE;EACjB;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,gBAAgB,EAAE;EACpB;IACE,WAAW,EAAE;EACf;IACE,8CAA8C;IAC9C,eAAe,EAAE;IACjB;MACE,UAAU,EAAE;EAChB;IACE,4BAA4B;IAC5B,cAAc;IACd,oBAAoB;IACpB,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,qBAAqB,EAAE;IACvB;MACE,cAAc;MACd,OAAO;MACP,gBAAgB;MAChB,cAAc;MACd,oBAAoB,EAAE;IACxB;MACE,eAAe,EAAE;EACrB;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,0CAA0C,EAAE;IAC5C;MACE,kBAAkB;MAClB,iBAAiB,EAAE;;AAEzB;EACE,uBAAuB;EACvB,eAAe,EAAE;EACjB;IACE,eAAe;IACf,gBAAgB,EAAE;EACpB;IACE,kBAAkB;IAClB,0CAA0C,EAAE;;AAEhD;EACE,kBAAkB,EAAE;EACpB;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,oBAAoB,EAAE;IACtB;MACE,mBAAmB;MACnB,WAAW;MACX,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,0CAA0C;MAC1C,mBAAmB;MACnB,uBAAuB;MACvB,mBAAmB;MACnB,eAAe;MACf,gBAAgB;MAChB,mBAAmB;MACnB,UAAU,EAAE;MACZ;QACE,iBAAiB;QACjB,iBAAiB,EAAE;MACrB;QACE,kBAAkB,EAAE;;AAE5B;EACE,aAAa;EACb,uBAAuB;EACvB,yBAAyB,EAAE;;AAE7B;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,0CAA0C;EAC1C,iBAAiB,EAAE;EACnB;IACE,UAAU,EAAE;EACd;IACE,2BAA2B,EAAE;IAC7B;MACE,cAAc,EAAE;EACpB;IACE,eAAe;IACf,gBAAgB,EAAE;EACpB;IACE,kBAAkB,EAAE;IACpB;MACE,iBAAiB;MACjB,6BAA6B;MAC7B,cAAc;MACd,kBAAkB;MAClB,gBAAgB,EAAE;MAClB;QACE,mBAAmB;QACnB,eAAe,EAAE;;AAEzB;EACE,aAAa;EACb,eAAe;EACf,iBAAiB,EAAE;EACnB;IACE,iBAAiB;IACjB,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,WAAW,EAAE;IACb;MACE,YAAY;MACZ,eAAe,EAAE;;AAEvB;EACE,qBAAqB;EACrB,kBAAkB,EAAE;EACpB;IACE,WAAW;IACX,UAAU;IACV,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,oBAAoB;IACpB,wBAAwB;IACxB,sCAAsC;IACtC,mCAAmC,EAAE;EACvC;IACE,qBAAqB,EAAE;EACzB;IACE,qBAAqB,EAAE;EACzB;IACE,qBAAqB,EAAE;;AAE3B;EACE;IACE,0BAA0B,EAAE;EAC9B;IACE,2BAA2B,EAAE;EAC/B;IACE,0BAA0B,EAAE,EAAE;;AAElC;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB,EAAE;;AAErB;EACE,aAAa;EACb,qCAAqC;EACrC,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,4CAA4C,EAAE;EAC9C;IACE,eAAe;IACf,8CAA8C;IAC9C,YAAY,EAAE;;AAElB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mBAAmB,EAAE;;AAEvB;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,YAAY;EACZ,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,kDAAkD,EAAE;EACpD;IACE,gBAAgB;IAChB,gBAAgB,EAAE;EACpB;IACE,aAAa;IACb,yBAAyB,EAAE;IAC3B;MACE,gBAAgB;MAChB,iBAAiB,EAAE","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@400;500&display=swap\");\n.fade-enter {\n  opacity: 0; }\n\n.fade-enter-active {\n  height: auto;\n  opacity: 1;\n  transition: opacity 300ms linear; }\n\n.fade-enter-done {\n  height: auto; }\n\n.fade-exit {\n  opacity: 1; }\n\n.fade-exit-active {\n  height: 0;\n  opacity: 0;\n  transition: opacity 300ms linear; }\n\n.fade-exit-done {\n  opacity: 0; }\n\n.fade-slide-enter {\n  opacity: 0;\n  transform: translateY(10px); }\n\n.fade-slide-enter-active {\n  opacity: 1;\n  transform: translateY(0);\n  transition: all 300ms cubic-bezier(0.35, 0.35, 0.35, 0.98); }\n\n.fade-slide-exit {\n  opacity: 1;\n  transform: translateY(0);\n  transition: all 300ms cubic-bezier(0.35, 0.35, 0.35, 0.98); }\n\n.fade-slide-exit-active {\n  opacity: 0;\n  transition: all 300ms linear; }\n\n.fade-slide-exit-done {\n  opacity: 0; }\n\n.slide-in-enter,\n.slide-in-appear {\n  opacity: .2;\n  transform: translateY(10px); }\n\n.slide-in-enter-active,\n.slide-in-appear-active {\n  opacity: 1;\n  transform: translateY(0);\n  transition: all 300ms cubic-bezier(0.35, 0.35, 0.35, 0.98); }\n\n.slide-in-exit,\n.slide-in-exit-active {\n  display: none; }\n\n.slide-enter,\n.slide-appear {\n  opacity: 0;\n  transform: translateY(10px); }\n\n.slide-enter-active,\n.slide-appear-active {\n  opacity: 1;\n  transform: translateY(0);\n  transition: all 300ms cubic-bezier(0.35, 0.35, 0.35, 0.98) 300ms; }\n\n.slide-exit,\n.slide-exit-active {\n  opacity: 0;\n  transform: translateY(10px);\n  transition: all 300ms cubic-bezier(0.35, 0.35, 0.35, 0.98); }\n\n.slide-enter-done {\n  display: block; }\n\n.slide-exit-done {\n  display: none; }\n\n.scale-in-enter,\n.scale-in-appear {\n  opacity: 0;\n  transform: scale(0.4);\n  transform-origin: 100% 100%; }\n\n.scale-in-enter-active,\n.scale-in-appear-active {\n  opacity: 1;\n  transform: scale(1);\n  transform-origin: 100% 100%;\n  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.1s;\n  transition-property: transform, opacity; }\n\n.scale-in-exit {\n  opacity: 1;\n  transform: scale(1); }\n\n.scale-in-exit-active {\n  opacity: 0;\n  transform: scale(0.4);\n  transform-origin: 100% 100%;\n  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  transition-property: transform, opacity; }\n\n.slide-in {\n  animation-delay: .15s;\n  animation-duration: .2s;\n  animation-fill-mode: both;\n  animation-name: slideIn;\n  animation-timing-function: cubic-bezier(0.35, 0.35, 0.35, 0.98);\n  transform-origin: bottom;\n  will-change: transform, opacity; }\n\n.fade-in,\n.fade-in-left,\n.fade-in-right {\n  animation-delay: .15s;\n  animation-duration: .3s;\n  animation-fill-mode: both;\n  animation-timing-function: ease-in; }\n\n.fade-in {\n  animation-name: fadeIn; }\n\n.fade-in-right {\n  animation-name: fadeInRight; }\n\n.fade-in-left {\n  animation-name: fadeInLeft; }\n\n@-webkit-keyframes animationPulse {\n  0% {\n    box-shadow: 0 0 0 0;\n    opacity: .5; }\n  40% {\n    box-shadow: 0 0 0 8px;\n    opacity: 0; }\n  80% {\n    box-shadow: 0 0 0 8px;\n    opacity: 0; }\n  100% {\n    box-shadow: 0 0 0 0;\n    opacity: 0; } }\n\n@-moz-keyframes animationPulse {\n  0% {\n    box-shadow: 0 0 0 0;\n    opacity: .5; }\n  40% {\n    box-shadow: 0 0 0 8px;\n    opacity: 0; }\n  80% {\n    box-shadow: 0 0 0 8px;\n    opacity: 0; }\n  100% {\n    box-shadow: 0 0 0 0;\n    opacity: 0; } }\n\n@keyframes animationPulse {\n  0% {\n    box-shadow: 0 0 0 0;\n    opacity: .5; }\n  40% {\n    box-shadow: 0 0 0 8px;\n    opacity: 0; }\n  80% {\n    box-shadow: 0 0 0 8px;\n    opacity: 0; }\n  100% {\n    box-shadow: 0 0 0 0;\n    opacity: 0; } }\n\n@-webkit-keyframes animationSpin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@-moz-keyframes animationSpin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes animationSpin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n@-webkit-keyframes shake {\n  10%, 90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%, 80% {\n    transform: translate3d(2px, 0, 0); }\n  30%, 50%, 70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%, 60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-moz-keyframes shake {\n  10%, 90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%, 80% {\n    transform: translate3d(2px, 0, 0); }\n  30%, 50%, 70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%, 60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@keyframes shake {\n  10%, 90% {\n    transform: translate3d(-1px, 0, 0); }\n  20%, 80% {\n    transform: translate3d(2px, 0, 0); }\n  30%, 50%, 70% {\n    transform: translate3d(-4px, 0, 0); }\n  40%, 60% {\n    transform: translate3d(4px, 0, 0); } }\n\n@-webkit-keyframes pop {\n  from {\n    opacity: 0;\n    transform: scale(0.5);\n    transform-origin: 50% 50%; }\n  to {\n    opacity: 1;\n    transform: scale(1);\n    transform-origin: 50% 50%; } }\n\n@-moz-keyframes pop {\n  from {\n    opacity: 0;\n    transform: scale(0.5);\n    transform-origin: 50% 50%; }\n  to {\n    opacity: 1;\n    transform: scale(1);\n    transform-origin: 50% 50%; } }\n\n@keyframes pop {\n  from {\n    opacity: 0;\n    transform: scale(0.5);\n    transform-origin: 50% 50%; }\n  to {\n    opacity: 1;\n    transform: scale(1);\n    transform-origin: 50% 50%; } }\n\n@-webkit-keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px); }\n  to {\n    opacity: 1;\n    transform: translateY(0); } }\n\n@-moz-keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px); }\n  to {\n    opacity: 1;\n    transform: translateY(0); } }\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px); }\n  to {\n    opacity: 1;\n    transform: translateY(0); } }\n\n@-webkit-keyframes fadeIn {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-moz-keyframes fadeIn {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@keyframes fadeIn {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n@-webkit-keyframes fadeInRight {\n  from {\n    opacity: 0;\n    transform: translateX(10px); }\n  to {\n    opacity: 1;\n    transform: none; } }\n\n@-moz-keyframes fadeInRight {\n  from {\n    opacity: 0;\n    transform: translateX(10px); }\n  to {\n    opacity: 1;\n    transform: none; } }\n\n@keyframes fadeInRight {\n  from {\n    opacity: 0;\n    transform: translateX(10px); }\n  to {\n    opacity: 1;\n    transform: none; } }\n\n@-webkit-keyframes fadeInLeft {\n  from {\n    opacity: 0;\n    transform: translateX(-10px); }\n  to {\n    opacity: 1;\n    transform: none; } }\n\n@-moz-keyframes fadeInLeft {\n  from {\n    opacity: 0;\n    transform: translateX(-10px); }\n  to {\n    opacity: 1;\n    transform: none; } }\n\n@keyframes fadeInLeft {\n  from {\n    opacity: 0;\n    transform: translateX(-10px); }\n  to {\n    opacity: 1;\n    transform: none; } }\n\nhtml,\nbody,\n#root,\n.salesmatch-widget {\n  height: 100%; }\n\nbody {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -ms-box-sizing: border-box;\n  -o-box-sizing: border-box;\n  box-sizing: border-box;\n  font-family: \"Poppins\", Helvetica, Arial, sans-serif;\n  margin: 0; }\n\n.salesmatch-widget {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -ms-box-sizing: border-box;\n  -o-box-sizing: border-box;\n  box-sizing: border-box;\n  font-size: 14px;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  line-height: 1.5;\n  margin: 0; }\n  .salesmatch-widget button,\n  .salesmatch-widget input,\n  .salesmatch-widget textarea {\n    font-family: \"Poppins\", Helvetica, Arial, sans-serif; }\n\n.icon {\n  height: 40px; }\n  .icon.white {\n    fill: #fff; }\n  .icon.attach {\n    fill: #686868;\n    height: 35px;\n    stroke: #686868; }\n\na {\n  color: #007bff; }\n\n.loader {\n  -webkit-animation-delay: 0;\n  -webkit-animation-duration: 1s;\n  -webkit-animation-name: animationSpin;\n  -webkit-animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n  -moz-animation-delay: 0;\n  -moz-animation-duration: 1s;\n  -moz-animation-name: animationSpin;\n  -moz-animation-iteration-count: infinite;\n  -moz-animation-timing-function: linear;\n  animation-delay: 0;\n  animation-duration: 1s;\n  animation-name: animationSpin;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n  border: 2px solid rgba(0, 0, 0, 0.3);\n  border-radius: 50%;\n  border-top: 2px solid rgba(0, 0, 0, 0.2);\n  height: 20px;\n  margin-right: -10px;\n  margin-top: -10px;\n  position: absolute;\n  right: 50%;\n  top: 50%;\n  width: 20px; }\n  .loader.bigger {\n    height: 28px;\n    margin-right: -14px;\n    margin-top: 0;\n    width: 28px; }\n  .loader.top-space {\n    margin-top: 100px; }\n\n.erxes-tooltip {\n  position: relative; }\n  .erxes-tooltip:hover {\n    cursor: pointer; }\n    .erxes-tooltip:hover::before {\n      opacity: 1;\n      transform: translateY(15%); }\n  .erxes-tooltip::before {\n    background: #fff;\n    border-radius: 10px;\n    border: 1px solid var(--border);\n    color: #333333;\n    content: attr(data-tooltip);\n    font-size: 12px;\n    left: auto;\n    max-width: 150px;\n    opacity: 0;\n    overflow: hidden;\n    padding: 5px 10px;\n    pointer-events: none;\n    position: absolute;\n    right: 0;\n    text-align: center;\n    text-overflow: ellipsis;\n    top: 100%;\n    transform: translateY(0%);\n    transition: transform 0.3s cubic-bezier(0.2, 1, 0.2, 1), opacity 0.2s cubic-bezier(0.2, 1, 0.2, 1);\n    white-space: nowrap;\n    will-change: transform, opacity;\n    z-index: 1; }\n  .erxes-tooltip.tooltip-center::before {\n    left: -100%; }\n\n.erxes-button {\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  background: #3ccc38;\n  border: 0;\n  border-radius: calc($border-radius / 2);\n  color: #fff;\n  font-size: 12px;\n  outline: 0;\n  padding: 10px 20px;\n  position: relative; }\n  .erxes-button span {\n    color: #fff; }\n  .erxes-button:hover, .erxes-button:focus {\n    background: #34bb30;\n    cursor: pointer;\n    text-decoration: none; }\n  .erxes-button.btn-block {\n    display: block;\n    width: 100%; }\n  .erxes-button.disabled {\n    cursor: not-allowed;\n    opacity: 0.7; }\n  .erxes-button.btn-primary {\n    background: #FD5C12; }\n    .erxes-button.btn-primary:hover, .erxes-button.btn-primary:focus {\n      background: #f34e02; }\n  .erxes-button.btn-outline {\n    background: transparent;\n    border: 1px solid #888;\n    color: #686868; }\n    .erxes-button.btn-outline:hover, .erxes-button.btn-outline:focus {\n      background: transparent;\n      opacity: 0.8; }\n  .erxes-button.hasMargin {\n    margin-right: 20px; }\n\n.erxes-objectlist-button {\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  background: #ea475d;\n  border: 0;\n  border-radius: calc($border-radius / 2);\n  color: #fff;\n  font-size: 12px;\n  outline: 0;\n  padding: 10px 20px;\n  position: relative; }\n  .erxes-objectlist-button span {\n    color: #fff; }\n  .erxes-objectlist-button:hover, .erxes-objectlist-button:focus {\n    background: #e73049;\n    cursor: pointer;\n    text-decoration: none; }\n  .erxes-objectlist-button.btn-block {\n    display: block; }\n  .erxes-objectlist-button.disabled {\n    cursor: not-allowed;\n    opacity: 0.7; }\n  .erxes-objectlist-button.btn-primary {\n    background: #FD5C12; }\n    .erxes-objectlist-button.btn-primary:hover, .erxes-objectlist-button.btn-primary:focus {\n      background: #f34e02; }\n  .erxes-objectlist-button.btn-outline {\n    background: transparent;\n    border: 1px solid #888;\n    color: #686868; }\n    .erxes-objectlist-button.btn-outline:hover, .erxes-objectlist-button.btn-outline:focus {\n      background: transparent;\n      opacity: 0.8; }\n\n.erxes-objectlist-cancel-button {\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  background: #eaebed;\n  border: 0;\n  border-radius: calc($border-radius / 2);\n  color: #888888;\n  font-size: 12px;\n  outline: 0;\n  padding: 10px 20px;\n  position: relative; }\n  .erxes-objectlist-cancel-button span {\n    color: #888888; }\n  .erxes-objectlist-cancel-button:hover, .erxes-objectlist-cancel-button:focus {\n    background: #dcdee1;\n    cursor: pointer;\n    text-decoration: none; }\n  .erxes-objectlist-cancel-button.btn-block {\n    display: block; }\n  .erxes-objectlist-cancel-button.disabled {\n    cursor: not-allowed;\n    opacity: 0.7; }\n  .erxes-objectlist-cancel-button.btn-primary {\n    background: #FD5C12; }\n    .erxes-objectlist-cancel-button.btn-primary:hover, .erxes-objectlist-cancel-button.btn-primary:focus {\n      background: #f34e02; }\n  .erxes-objectlist-cancel-button.btn-outline {\n    background: transparent;\n    border: 1px solid #888;\n    color: #686868; }\n    .erxes-objectlist-cancel-button.btn-outline:hover, .erxes-objectlist-cancel-button.btn-outline:focus {\n      background: transparent;\n      opacity: 0.8; }\n\n.erxes-form-fields {\n  margin-right: -20px; }\n  .erxes-form-fields .form-group {\n    padding-right: 20px;\n    box-sizing: border-box;\n    width: 100%; }\n\n.form-control {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -ms-box-sizing: border-box;\n  -o-box-sizing: border-box;\n  box-sizing: border-box;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  -webkit-appearance: none;\n  background-color: #f1f1f1;\n  border-radius: 10px;\n  color: #111111;\n  display: block;\n  font-size: 14px;\n  height: 40px;\n  line-height: 1.42857143;\n  margin-top: 8px;\n  outline: 0;\n  width: 100%;\n  padding: 10px; }\n  .form-control.compact {\n    height: 30px;\n    padding: 5px; }\n  .form-control::placeholder {\n    color: #808080; }\n  .form-control[type=\"checkbox\"], .form-control[type=\"radio\"] {\n    display: inline-block;\n    height: inherit;\n    margin: 0 8px 5px 0;\n    width: inherit;\n    background: none;\n    box-shadow: none;\n    -webkit-appearance: checkbox; }\n  .form-control[type=\"radio\"] {\n    -webkit-appearance: radio; }\n\nselect.form-control,\nselect.form-control:focus,\n.select.form-control,\n.select.form-control:focus {\n  background: url(http://cdn1.iconfinder.com/data/icons/cc_mono_icon_set/blacks/16x16/br_down.png) no-repeat right;\n  background-size: 8px;\n  background-position-x: calc(100% - 10px); }\n\n.select.form-control {\n  height: auto;\n  min-height: 36px; }\n\n.msf_multiselect_container .msf_multiselect {\n  border: 1px solid #e4e4e4;\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  z-index: 240; }\n\n.msf_multiselect li {\n  padding: 5px 10px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  margin: 0 10px 3px 10px;\n  border-radius: 4px; }\n  .msf_multiselect li:hover, .msf_multiselect li:focus, .msf_multiselect li.active {\n    background-color: #f0f0f0; }\n\n.msf_multiselect_container .msf_multiselect {\n  max-height: 300px;\n  overflow: auto;\n  background-color: #fff;\n  right: 20px;\n  left: 20px; }\n\n.msf_multiselect_container .form-control .selectedLabels {\n  padding: 1px 6px;\n  background: #f0f0f0;\n  color: #768192;\n  border: 1px solid #d8dbe0;\n  border-radius: 25px;\n  display: inline-block;\n  font-size: 12px;\n  margin: 3px 6px 3px 0; }\n\n.msf_multiselect_container .closeBtn {\n  padding-left: 4px;\n  cursor: pointer;\n  color: rgba(0, 0, 0, 0.5);\n  font-weight: bold; }\n\n.msf_multiselect_container .closeBtn.readOnly {\n  cursor: unset; }\n\n.msf_multiselect_container .hidden {\n  display: none !important; }\n\n.msf_multiselect .searchbox {\n  width: -moz-available;\n  width: -webkit-fill-available;\n  padding: 8px;\n  margin: 0;\n  border: 0;\n  border-bottom: 1px solid #ddd; }\n  .msf_multiselect .searchbox:focus {\n    outline: 0;\n    border-color: #2196f3; }\n\n.msf_multiselect_container .msf_multiselect.offdropdown {\n  position: unset; }\n\n.form-group {\n  margin-bottom: 15px; }\n  .form-group.compact {\n    margin-bottom: 0; }\n  .form-group .control-label {\n    font-weight: 500;\n    max-width: 100%; }\n    .form-group .control-label > .required {\n      margin-left: 2px;\n      color: #ff0000; }\n  .form-group .description {\n    color: #686868;\n    display: block;\n    font-size: 13px; }\n    .form-group .description p {\n      margin: 0; }\n    .form-group .description ul {\n      padding-left: 20px; }\n  .form-group .check-control {\n    margin-top: 8px; }\n  .form-group textarea.form-control {\n    height: auto;\n    min-height: 70px; }\n  .form-group .error {\n    color: #ea475d;\n    font-size: 12px;\n    margin-left: 4px; }\n\n.erxes-callout-body {\n  color: #5c5c5c;\n  display: block;\n  margin-bottom: 10px;\n  overflow: hidden;\n  width: 100%; }\n  .erxes-callout-body img {\n    float: left;\n    margin-right: 10px;\n    max-width: 30%; }\n\n::-webkit-scrollbar {\n  border-radius: 0;\n  width: 8px; }\n\n::-webkit-scrollbar-thumb {\n  background: rgba(215, 215, 215, 0.7);\n  border-radius: 4px;\n  box-shadow: inset 0 -3px 0 0 transparent, inset 0 3px 0 0 transparent; }\n\n::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0.05); }\n\n.salesmatch-launcher {\n  animation: pop 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) 1;\n  background-color: #ED3D07;\n  background-image: url(\"https://cdn.salesmatch.ai/portal-demo.salesmatch.ai_0.08122210118098172chat.png\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  border-radius: 28px;\n  bottom: 8px;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);\n  color: #ED3D07;\n  cursor: pointer;\n  height: 56px;\n  left: auto;\n  line-height: 56px;\n  margin-left: auto;\n  margin-top: auto;\n  pointer-events: auto;\n  position: fixed !important;\n  right: 0;\n  text-align: center;\n  top: auto;\n  transition: box-shadow .3s ease-in-out, background-image .3s ease-in;\n  width: 56px;\n  z-index: 2147483646; }\n  .salesmatch-launcher span {\n    background: #ea475d;\n    border-radius: 10px;\n    color: #fff;\n    display: block;\n    font-size: 10px;\n    height: 20px;\n    line-height: 20px;\n    position: absolute;\n    right: -2px;\n    text-align: center;\n    top: -5px;\n    width: 20px; }\n  .salesmatch-launcher.close, .salesmatch-launcher.close-launcher {\n    background-image: url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"22\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><line x1=\"18\" y1=\"6\" x2=\"6\" y2=\"18\" /><line x1=\"6\" y1=\"6\" x2=\"18\" y2=\"18\" /></svg>') !important;\n    background-size: 20px !important;\n    background-position: 50%;\n    transition: box-shadow .3s ease-in-out, background-image .3s ease-in; }\n    .salesmatch-launcher.close::before, .salesmatch-launcher.close-launcher::before {\n      animation: none; }\n  .salesmatch-launcher::before {\n    -webkit-animation-delay: 0.5s;\n    -webkit-animation-duration: 3s;\n    -webkit-animation-name: animationPulse;\n    -webkit-animation-iteration-count: 10;\n    -webkit-animation-timing-function: linear;\n    -moz-animation-delay: 0.5s;\n    -moz-animation-duration: 3s;\n    -moz-animation-name: animationPulse;\n    -moz-animation-iteration-count: 10;\n    -moz-animation-timing-function: linear;\n    animation-delay: 0.5s;\n    animation-duration: 3s;\n    animation-name: animationPulse;\n    animation-iteration-count: 10;\n    animation-timing-function: linear;\n    border-radius: 50%;\n    color: inherit;\n    content: '';\n    height: 100%;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 100%; }\n  .salesmatch-launcher.alternative-launcher {\n    width: 120px;\n    height: 120px; }\n\n.erxes-messenger-embed .erxes-topbar {\n  border-radius: 0; }\n\n.erxes-topbar {\n  background: #ED3D07;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  color: #fff;\n  flex-shrink: 0;\n  text-align: center;\n  width: 100%; }\n  .erxes-topbar .topbar-button {\n    width: auto;\n    height: auto;\n    line-height: initial; }\n    .erxes-topbar .topbar-button-trigger {\n      display: flex;\n      justify-content: start;\n      align-items: center;\n      gap: .5rem; }\n  .erxes-topbar .erxes-middle {\n    display: inline-block; }\n\n.topbar-button {\n  -webkit-transition: background 0.3s ease-in-out;\n  -moz-transition: background 0.3s ease-in-out;\n  -ms-transition: background 0.3s ease-in-out;\n  -o-transition: background 0.3s ease-in-out;\n  transition: background 0.3s ease-in-out;\n  background: none;\n  border: 0;\n  cursor: pointer;\n  display: block;\n  outline: none;\n  padding: 0;\n  text-align: center;\n  position: relative;\n  z-index: 100; }\n  .topbar-button.dropdown-open ul {\n    visibility: visible;\n    opacity: 1; }\n  .topbar-button ul {\n    -webkit-box-shadow: 0 7px 25px 5px rgba(0, 0, 0, 0.1);\n    -moz-box-shadow: 0 7px 25px 5px rgba(0, 0, 0, 0.1);\n    box-shadow: 0 7px 25px 5px rgba(0, 0, 0, 0.1);\n    -webkit-transition: all 0.2s ease-in-out;\n    -moz-transition: all 0.2s ease-in-out;\n    -ms-transition: all 0.2s ease-in-out;\n    -o-transition: all 0.2s ease-in-out;\n    transition: all 0.2s ease-in-out;\n    background-color: var(--accent);\n    border-radius: 10px;\n    border-top-right-radius: 0;\n    font-size: var(--font-size-xs);\n    list-style: none;\n    position: absolute;\n    right: 0;\n    padding-block: 10px;\n    margin: 0;\n    text-align: left;\n    top: 100%;\n    transform: translateY(10px);\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    cursor: default;\n    overflow: hidden;\n    visibility: hidden;\n    opacity: 0; }\n    .topbar-button ul li a {\n      padding-inline: 10px;\n      white-space: nowrap;\n      text-decoration: none;\n      color: var(--accent-foreground);\n      display: block; }\n      .topbar-button ul li a:hover {\n        text-decoration: underline; }\n\n.erxes-staff-profile {\n  line-height: 1.3em;\n  margin-top: 15px;\n  position: relative;\n  text-align: left; }\n  .erxes-staff-profile img {\n    border-radius: 20px;\n    float: left;\n    height: 40px;\n    overflow: hidden;\n    width: 40px; }\n  .erxes-staff-profile > div {\n    margin-left: 50px; }\n\n.erxes-state {\n  background-color: #ddd;\n  border-radius: 10px;\n  display: inline-block;\n  height: 8px;\n  margin-bottom: 1px;\n  width: 8px; }\n  .erxes-state.online {\n    background-color: #3ccc38; }\n\n.erxes-topbar-title {\n  align-self: center;\n  font-weight: 600;\n  line-height: 1.2em;\n  overflow: hidden; }\n  .erxes-topbar-title > div span {\n    display: inline;\n    opacity: .8; }\n  .erxes-topbar-title span {\n    display: block;\n    font-size: 11px;\n    font-weight: 300;\n    margin-top: 3px;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    max-width: 100%; }\n\n[class*=\" erxes-icon-\"],\n[class^=erxes-icon-] {\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  display: block;\n  height: 32px;\n  width: 32px; }\n\n.erxes-icon-alarm {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/alarm.svg\"); }\n\n.erxes-icon-bar-chart {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/bar-chart.svg\"); }\n\n.erxes-icon-book {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/book.svg\"); }\n\n.erxes-icon-briefcase {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/briefcase.svg\"); }\n\n.erxes-icon-calculator {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/calculator.svg\"); }\n\n.erxes-icon-calendar {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/calendar.svg\"); }\n\n.erxes-icon-clipboard {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/clipboard.svg\"); }\n\n.erxes-icon-cloudcomputing {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/cloudcomputing.svg\"); }\n\n.erxes-icon-compass {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/compass.svg\"); }\n\n.erxes-icon-computer {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/computer.svg\"); }\n\n.erxes-icon-dashboard {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/dashboard.svg\"); }\n\n.erxes-icon-diagram {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/diagram.svg\"); }\n\n.erxes-icon-diamond {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/diamond.svg\"); }\n\n.erxes-icon-bar-earthgrid {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/bar-earthgrid.svg\"); }\n\n.erxes-icon-flag {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/flag.svg\"); }\n\n.erxes-icon-folder {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/folder.svg\"); }\n\n.erxes-icon-head-1 {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/head-1.svg\"); }\n\n.erxes-icon-home {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/home.svg\"); }\n\n.erxes-icon-idea {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/idea.svg\"); }\n\n.erxes-icon-laptop {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/laptop.svg\"); }\n\n.erxes-icon-like {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/like.svg\"); }\n\n.erxes-icon-medal {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/medal.svg\"); }\n\n.erxes-icon-megaphone {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/megaphone.svg\"); }\n\n.erxes-icon-paste {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/paste.svg\"); }\n\n.erxes-icon-piechart {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/piechart.svg\"); }\n\n.erxes-icon-piggybank {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/piggybank.svg\"); }\n\n.erxes-icon-puzzle {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/puzzle.svg\"); }\n\n.erxes-icon-scale {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/scale.svg\"); }\n\n.erxes-icon-settings {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/settings.svg\"); }\n\n.erxes-icon-star {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/star.svg\"); }\n\n.erxes-icon-tools {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/tools.svg\"); }\n\n.erxes-icon-umbrella {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/umbrella.svg\"); }\n\n.erxes-icon-paintpalette {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/paintpalette.svg\"); }\n\n.erxes-icon-users {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/users.svg\"); }\n\n.erxes-icon-stamp {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/stamp.svg\"); }\n\n.erxes-icon-phone-call {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/phone-call.svg\"); }\n\n.erxes-icon-magicwand {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/magicwand.svg\"); }\n\n.erxes-icon-folder {\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/icons/folder.svg\"); }\n\n.erxes-messenger-embed .head-wrapper {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  height: auto !important; }\n\n.head-wrapper {\n  background-color: var(--background, #fff);\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  transition: height 0.25s ease-in-out;\n  background-image: url(\"https://ui.app.salesmatch.ai/images/icons/pattern.png\");\n  background-repeat: repeat;\n  background-size: cover; }\n  @media screen and (max-width: 384px) {\n    .head-wrapper {\n      border: none;\n      border-radius: 0; } }\n\n.erxes-topbar {\n  align-items: center;\n  background: none;\n  display: flex;\n  justify-content: space-around;\n  min-height: 70px;\n  padding: 0;\n  width: auto;\n  z-index: 2; }\n  .erxes-topbar.expanded {\n    height: auto; }\n    .erxes-topbar.expanded .erxes-topbar-title {\n      margin-right: 55px; }\n    .erxes-topbar.expanded .loader-wrapper {\n      margin-left: -50px; }\n  .erxes-topbar .erxes-middle {\n    display: flex;\n    align-items: flex-start;\n    justify-content: flex-start;\n    flex: 1;\n    flex-shrink: 0;\n    width: 100%;\n    max-width: 100%;\n    height: 100%;\n    transition-property: background, opacity; }\n  .erxes-topbar .welcome-info {\n    display: flex;\n    flex-direction: column;\n    align-items: center; }\n    .erxes-topbar .welcome-info h3 {\n      font-size: 2.25rem;\n      font-weight: 500;\n      margin: 0;\n      text-overflow: ellipsis;\n      overflow: hidden; }\n    .erxes-topbar .welcome-info .description {\n      opacity: 0.8;\n      font-size: 13px;\n      line-height: 21px; }\n  .erxes-topbar .socials a {\n    margin-right: 12px;\n    opacity: 0.6; }\n    .erxes-topbar .socials a:hover {\n      opacity: 1; }\n    .erxes-topbar .socials a:last-of-type {\n      margin-right: 0; }\n  .erxes-topbar .socials img {\n    height: 18px;\n    width: 18px; }\n  .erxes-topbar .erxes-topbar-title.limited {\n    max-width: 260px; }\n    .erxes-topbar .erxes-topbar-title.limited > div,\n    .erxes-topbar .erxes-topbar-title.limited > span {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap; }\n\n.erxes-supporters {\n  align-items: baseline;\n  display: flex; }\n  .erxes-supporters .erxes-supporter {\n    flex: 1;\n    flex-shrink: 0;\n    margin-right: -8px; }\n    .erxes-supporters .erxes-supporter:last-of-type {\n      margin: 0; }\n  .erxes-supporters .erxes-staff-name {\n    opacity: 0.8;\n    display: none;\n    font-size: 12px;\n    text-transform: capitalize; }\n  .erxes-supporters.full {\n    padding-top: 10px; }\n    .erxes-supporters.full .erxes-supporter {\n      margin: 0;\n      padding: 0 5px; }\n    .erxes-supporters.full .erxes-staff-name {\n      display: block; }\n    .erxes-supporters.full .avatar {\n      display: inline-block; }\n      .erxes-supporters.full .avatar img {\n        border: 0; }\n    .erxes-supporters.full .erxes-tooltip::before {\n      display: none; }\n\n.erxes-profile {\n  text-align: left; }\n  .erxes-profile .top-content {\n    align-items: center;\n    display: flex; }\n    .erxes-profile .top-content .user-name {\n      flex: 1;\n      font-size: 13px;\n      margin-left: 10px;\n      max-width: 200px;\n      overflow: hidden; }\n    .erxes-profile .top-content span {\n      opacity: 0.8;\n      display: block;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      font-size: .8em; }\n    .erxes-profile .top-content h5 {\n      font-size: 13px;\n      margin: 0; }\n  .erxes-profile .bottom-content {\n    opacity: 0.8; }\n    .erxes-profile .bottom-content p {\n      font-size: 13px;\n      margin-bottom: 0; }\n    .erxes-profile .bottom-content img {\n      margin-top: 10px; }\n\n.avatar {\n  position: relative; }\n  .avatar img {\n    background: rgba(0, 0, 0, 0.2);\n    border: 2px solid transparent;\n    border-radius: 22px;\n    display: block;\n    object-fit: cover;\n    object-position: center;\n    height: 40px;\n    width: 40px; }\n  .avatar .erxes-state {\n    bottom: 2px;\n    position: absolute;\n    right: 2px;\n    z-index: 2; }\n\n.erxes-home-container {\n  flex: 1;\n  overflow: hidden;\n  background: #fff;\n  padding-top: 0 !important; }\n  .erxes-home-container .integration-box {\n    animation-delay: .4s;\n    background: #fff;\n    border-radius: 10px; }\n  .erxes-home-container .empty-list {\n    padding: 0 20px 20px; }\n    .erxes-home-container .empty-list p {\n      color: #888;\n      margin-top: 0; }\n  .erxes-home-container .head-wrapper .erxes-middle {\n    justify-content: flex-start; }\n  .erxes-home-container .erxes-home-content {\n    overflow: auto;\n    padding: 24px; }\n    .erxes-home-container .erxes-home-content.tabbed {\n      margin-top: 0; }\n    .erxes-home-container .erxes-home-content .scroll-wrapper {\n      height: calc(100% - 60px);\n      overflow: auto; }\n\n.erxes-welcome {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: center;\n  overflow-wrap: break-word;\n  text-align: left;\n  word-wrap: break-word; }\n  .erxes-welcome .erxes-supporters {\n    padding-top: 10px; }\n    .erxes-welcome .erxes-supporters .erxes-supporter {\n      display: inline-block;\n      flex: none;\n      margin-right: 10px; }\n    .erxes-welcome .erxes-supporters img {\n      border: 0; }\n  .erxes-welcome .erxes-topbar-title {\n    display: none; }\n  .erxes-welcome .erxes-tooltip::before {\n    top: -100%; }\n  .erxes-welcome .loader-wrapper {\n    margin-left: -50px; }\n  .erxes-welcome.tabbed {\n    padding-bottom: 60px; }\n  .erxes-welcome .assist-bar {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 10px; }\n    .erxes-welcome .assist-bar time {\n      opacity: 0.7;\n      font-size: 11px; }\n    .erxes-welcome .assist-bar .socials {\n      margin-right: 30px; }\n  .erxes-welcome .server-info {\n    padding: 10px 0;\n    font-size: 12px; }\n    .erxes-welcome .server-info p {\n      margin: 0; }\n\n.erxes-tab {\n  border-bottom: 1px solid #ddd;\n  color: #000;\n  cursor: pointer;\n  display: flex;\n  position: relative; }\n  .erxes-tab .indicator {\n    background: #ED3D07;\n    bottom: -1px;\n    height: 2px;\n    left: 50%;\n    position: absolute;\n    transition: left .3s ease;\n    width: 50%; }\n    .erxes-tab .indicator.left {\n      left: 0; }\n  .erxes-tab > span {\n    align-items: center;\n    background: #fff;\n    display: flex;\n    flex: 1;\n    font-size: 11px;\n    justify-content: center;\n    text-align: center;\n    text-transform: uppercase;\n    transition: all .3s ease; }\n    .erxes-tab > span:last-of-type {\n      border-left: 1px solid #ddd; }\n\n.loader-wrapper {\n  height: 70px;\n  position: relative; }\n\n.erxes-messenger {\n  border-radius: 10px;\n  bottom: 76px;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  height: calc(100% - 70px);\n  max-height: 720px;\n  overflow: auto;\n  position: absolute;\n  right: 0;\n  width: 100%;\n  z-index: 2147483647;\n  background-color: #fff; }\n  .erxes-messenger.erxes-messenger-embed {\n    position: static;\n    right: initial;\n    bottom: initial;\n    z-index: initial;\n    width: 100%;\n    height: 100%;\n    border: none;\n    border-radius: 0; }\n    .erxes-messenger.erxes-messenger-embed .erxes-message-sender {\n      border-radius: 0; }\n  .erxes-messenger > * {\n    height: 100%; }\n  .erxes-messenger > div.visible {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    visibility: visible; }\n  .erxes-messenger > div.hide {\n    display: none;\n    visibility: hidden; }\n  @media screen and (max-width: 384px) {\n    .erxes-messenger {\n      border: none !important;\n      border-radius: 0;\n      bottom: 70px;\n      height: calc(100% - 70px);\n      max-height: none;\n      right: 0;\n      width: 100%; } }\n\n.accquire-information {\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1; }\n  @media screen and (max-width: 384px) {\n    .accquire-information {\n      height: auto !important; } }\n  .accquire-information .type {\n    margin-top: 0; }\n    .accquire-information .type span {\n      cursor: pointer;\n      display: inline-block;\n      margin-right: 10px; }\n      .accquire-information .type span.current {\n        border-bottom: 1px solid;\n        font-weight: bold; }\n  .accquire-information .form {\n    display: flex;\n    flex-direction: row;\n    flex-shrink: 0;\n    flex-wrap: wrap;\n    margin-top: 5px; }\n    @media screen and (max-width: 384px) {\n      .accquire-information .form {\n        gap: 10px; } }\n    .accquire-information .form.invalid {\n      -webkit-animation-delay: 0;\n      -webkit-animation-duration: 0.8s;\n      -webkit-animation-name: shake;\n      -webkit-animation-iteration-count: initial;\n      -webkit-animation-timing-function: cubic-bezier(0.36, 0.07, 0.19, 0.97);\n      -moz-animation-delay: 0;\n      -moz-animation-duration: 0.8s;\n      -moz-animation-name: shake;\n      -moz-animation-iteration-count: initial;\n      -moz-animation-timing-function: cubic-bezier(0.36, 0.07, 0.19, 0.97);\n      animation-delay: 0;\n      animation-duration: 0.8s;\n      animation-name: shake;\n      animation-iteration-count: initial;\n      animation-timing-function: cubic-bezier(0.36, 0.07, 0.19, 0.97); }\n      .accquire-information .form.invalid input {\n        border-color: #ea475d !important; }\n    @media screen and (max-width: 384px) {\n      .accquire-information .form .input-container,\n      .accquire-information .form button {\n        width: 100% !important; } }\n    .accquire-information .form input {\n      background: #faf9fb;\n      border: 1px solid #ddd;\n      border-bottom-left-radius: calc($border-radius / 2);\n      border-top-left-radius: calc($border-radius / 2);\n      box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.07);\n      font-size: 14px; }\n    .accquire-information .form input {\n      -webkit-appearance: none;\n      box-sizing: border-box;\n      flex: 1;\n      max-width: 15rem;\n      height: 40px;\n      margin-right: 0;\n      outline: 0;\n      padding: 10px 15px;\n      width: 100%; }\n      @media screen and (max-width: 384px) {\n        .accquire-information .form input {\n          font-size: 16px; } }\n      @media screen and (min-width: 610px) {\n        .accquire-information .form input {\n          max-width: 300px; } }\n    .accquire-information .form button {\n      background-color: #ED3D07;\n      border: 0;\n      border-radius: 0;\n      border-bottom-right-radius: calc($border-radius / 2);\n      border-top-right-radius: calc($border-radius / 2);\n      height: 40px;\n      margin: 0;\n      outline: 0;\n      padding: 4px;\n      position: relative;\n      width: 40px; }\n      .accquire-information .form button svg {\n        margin-top: 3px; }\n      .accquire-information .form button .loader {\n        border: 2px solid rgba(255, 255, 255, 0.8);\n        border-top: 2px solid rgba(255, 255, 255, 0.3);\n        height: 16px;\n        width: 16px; }\n  @media screen and (max-width: 384px) {\n    .accquire-information {\n      height: 100%; } }\n\n.websiteApp {\n  height: 100%;\n  border: none; }\n\n.websiteApp-home {\n  padding: 0px 20px 20px; }\n  .websiteApp-home p {\n    margin: 0px;\n    padding: 0px;\n    margin-bottom: 15px; }\n  .websiteApp-home button:hover {\n    box-shadow: 0 5px 20px 5px rgba(0, 0, 0, 0.1); }\n\n#page-root #erxes-video-container {\n  background: #fff;\n  position: absolute;\n  right: 0;\n  top: -30px;\n  bottom: 0;\n  width: 100%;\n  transition: all ease 0.2s; }\n  #page-root #erxes-video-container .erxes-toggle-video {\n    width: 42px;\n    height: 28px;\n    position: absolute;\n    bottom: 76px;\n    right: 5px;\n    background-size: 100%;\n    cursor: pointer;\n    background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNjEyIDQ1NCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNjEyIDQ1NDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+LnN0MHtmaWxsOiNGRkZGRkY7fTwvc3R5bGU+PHBhdGggaWQ9Inl0cC1pZC0yMyIgY2xhc3M9InN0MCIgZD0iTTI4MiwyNDJoMTM2VjE0MEgyODJWMjQyTDI4MiwyNDJ6IE0xMTksMTA2djIzOC4zYzAsMTguNywxNS4zLDMzLjcsMzQsMzMuN2gzMDZjMTguNywwLDM0LTE1LDM0LTMzLjdWMTA2YzAtMTguNy0xNS4zLTM0LTM0LTM0SDE1M0MxMzQuMyw3MiwxMTksODcuMywxMTksMTA2TDExOSwxMDZ6IE0xNTMsMTA1LjdoMzA2djIzOC45SDE1M1YxMDUuN0wxNTMsMTA1Ljd6Ii8+PC9zdmc+); }\n\n#page-root.mini-video #erxes-video-container {\n  width: 290px;\n  height: 220px;\n  right: 8px;\n  overflow: hidden;\n  box-shadow: 0 0 6px 1px rgba(0, 0, 0, 0.1);\n  border-radius: 5px; }\n  #page-root.mini-video #erxes-video-container .erxes-toggle-video {\n    width: 26px;\n    height: 26px;\n    right: 8px;\n    bottom: 10px;\n    background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDI0IDI0OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHN0eWxlIHR5cGU9InRleHQvY3NzIj4uc3Qwe2ZpbGw6I0ZGRkZGRjt9PC9zdHlsZT48Zz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMi4wMDAwMDAsIDEyLjAwMDAwMCkgc2NhbGUoLTEsIDEpIHRyYW5zbGF0ZSgtMTIuMDAwMDAwLCAtMTIuMDAwMDAwKSAiPjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik01LDE5VjVoMTR2N2gyVjVjMC0xLjEtMC45LTItMi0ySDVDMy45LDMsMywzLjksMyw1djE0YzAsMS4xLDAuOSwyLDIsMmg3di0ySDV6IE0yMSwxNGgtMnYzLjZMOS4yLDcuOEw3LjgsOS4ybDkuOCw5LjhIMTR2Mmg3VjE0eiIvPjwvZz48L2c+PC9zdmc+); }\n  #page-root.mini-video #erxes-video-container iframe {\n    height: 286px; }\n\n#page-root iframe#erxes-video-iframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n  outline: 0; }\n\n.erxes-conversation-detail {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  max-height: 100%; }\n\n.erxes-conversation-content {\n  display: flex;\n  flex: 1;\n  position: relative; }\n  .erxes-conversation-content .erxes-content-wrapper {\n    display: flex;\n    flex-direction: column;\n    width: 100%; }\n\n.erxes-conversation-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  margin-bottom: 70px; }\n\n.erxes-conversation-init {\n  list-style: none;\n  margin: 0;\n  padding: 0; }\n\n.erxes-last-section {\n  list-style: none;\n  position: fixed;\n  bottom: 76px;\n  background: #fff;\n  border-top: 1px solid #eaebed;\n  width: 76.7%;\n  margin: 0px;\n  padding: 12px;\n  left: 42px; }\n  .erxes-last-section > .erxes-create-btn {\n    background: #e73049;\n    cursor: pointer;\n    display: grid;\n    grid-template-columns: 20% 80%;\n    justify-items: center;\n    align-items: center;\n    color: #fff;\n    border-radius: 5px; }\n    .erxes-last-section > .erxes-create-btn > .erxes-start-text {\n      padding-bottom: 5px; }\n\n.erxes-list-item {\n  -webkit-transition: background 0.3s ease-in-out;\n  -moz-transition: background 0.3s ease-in-out;\n  -ms-transition: background 0.3s ease-in-out;\n  -o-transition: background 0.3s ease-in-out;\n  transition: background 0.3s ease-in-out;\n  overflow: hidden;\n  display: flex;\n  justify-content: start;\n  align-items: center;\n  gap: 10px;\n  position: relative; }\n  .erxes-list-item:hover {\n    cursor: pointer; }\n  .erxes-list-item.unread .erxes-last-message {\n    color: #333333;\n    font-weight: bold; }\n  .erxes-list-item img.erxes-left-side {\n    width: 40px;\n    height: 40px; }\n  .erxes-list-item .erxes-left-side {\n    border-radius: 25px;\n    text-align: center; }\n    .erxes-list-item .erxes-left-side > span {\n      align-items: center;\n      background: rgba(0, 0, 0, 0.04);\n      border: 1px solid #ddd;\n      border-radius: 21px;\n      box-sizing: border-box;\n      display: flex;\n      height: 42px;\n      justify-content: center;\n      width: 42px; }\n    .erxes-list-item .erxes-left-side svg {\n      stroke: #888; }\n  .erxes-list-item:last-child .erxes-right-side {\n    border: none; }\n  .erxes-list-item .erxes-right-side {\n    border-bottom: 1px solid #eaebed;\n    padding: 20px 20px 20px 0;\n    width: 100%; }\n  .erxes-list-item .erxes-right-plus {\n    border-bottom: 1px solid #eaebed;\n    padding: 10px 10px 10px 0;\n    width: 100%; }\n  .erxes-list-item .erxes-name {\n    font-weight: 400; }\n    .erxes-list-item .erxes-name > span {\n      color: #888; }\n    .erxes-list-item .erxes-name > input {\n      padding: 10px 10px;\n      line-height: 1.4;\n      border-radius: 5px;\n      display: block;\n      width: -webkit-fill-available;\n      outline: none;\n      border: 1px solid #ccc; }\n  .erxes-list-item .erxes-last-message {\n    color: #686868;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap; }\n  .erxes-list-item .erxes-date {\n    color: #888;\n    float: right;\n    font-size: 12px;\n    margin-top: 2px; }\n    .erxes-list-item .erxes-date.erxes-tooltip::before {\n      right: 0; }\n\n.erxes-messages-list {\n  list-style: none;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start; }\n  .erxes-messages-list li {\n    margin-bottom: 10px;\n    position: relative; }\n    .erxes-messages-list li.from-customer .erxes-tooltip::before {\n      right: 0; }\n    .erxes-messages-list li .date {\n      color: #686868;\n      font-size: 11px;\n      margin-left: 50px; }\n\n.erxes-messages-background {\n  background-color: #faf9fb;\n  display: flex;\n  flex: 1;\n  flex-direction: column; }\n  .erxes-messages-background.bg-1 {\n    background-repeat: repeat;\n    background-position: 0 0;\n    background-image: url(\"https://ui.app.salesmatch.ai/images/icons/bg-1.png\"); }\n  .erxes-messages-background.bg-2 {\n    background-repeat: repeat;\n    background-position: 0 0;\n    background-image: url(\"https://ui.app.salesmatch.ai/images/icons/bg-2.png\"); }\n  .erxes-messages-background.bg-3 {\n    background-repeat: repeat;\n    background-position: 0 0;\n    background-image: url(\"https://ui.app.salesmatch.ai/images/icons/bg-3.png\"); }\n  .erxes-messages-background.bg-4 {\n    background-repeat: repeat;\n    background-position: 0 0;\n    background-image: url(\"https://ui.app.salesmatch.ai/images/icons/bg-4.png\"); }\n\n.erxes-spacial-message {\n  color: #686868;\n  margin-bottom: 15px; }\n  .erxes-spacial-message.right {\n    line-height: normal;\n    text-align: right;\n    color: #888;\n    margin-bottom: 15px; }\n  .erxes-spacial-message.away {\n    margin-bottom: 0;\n    margin-top: 15px; }\n  .erxes-spacial-message.ml50 {\n    margin-left: 50px; }\n  .erxes-spacial-message.with-background {\n    background-color: #eaebed;\n    border-radius: 10px;\n    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.2);\n    padding: 20px; }\n  .erxes-spacial-message ~ .erxes-spacial-message {\n    margin-top: 15px; }\n\n.erxes-message {\n  background-color: #eaebed;\n  border-radius: var(--radius);\n  border-bottom-left-radius: 0;\n  color: #686868;\n  display: inline-block;\n  margin: 0 20px 5px 50px;\n  padding: 10px;\n  position: relative;\n  text-align: left;\n  word-break: break-word; }\n  .erxes-message.top {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: var(--radius); }\n  .erxes-message.from-customer {\n    background-color: #ED3D07;\n    border-bottom-left-radius: var(--radius);\n    border-bottom-right-radius: 0;\n    color: #fff;\n    margin: 0 0 5px 20px; }\n    .erxes-message.from-customer a {\n      color: #fff; }\n    .erxes-message.from-customer.gray {\n      background-color: #eaebed;\n      color: #686868;\n      margin-bottom: 0; }\n  .erxes-message.attachment {\n    background: #fff !important;\n    border: 0; }\n    .erxes-message.attachment > span {\n      display: none; }\n  .erxes-message p {\n    margin-top: 0;\n    word-break: break-word;\n    margin-bottom: 10px; }\n    .erxes-message p:last-child {\n      margin-bottom: 0; }\n  .erxes-message img {\n    max-width: 240px; }\n  .erxes-message ul {\n    list-style-type: disc;\n    padding-left: 20px; }\n    .erxes-message ul li {\n      margin-bottom: 5px;\n      overflow: visible; }\n  .erxes-message ol {\n    list-style-type: decimal;\n    padding-left: 20px; }\n    .erxes-message ol li {\n      margin-bottom: 5px;\n      overflow: visible; }\n  .erxes-message h3 {\n    font-size: 16px;\n    margin-bottom: 8px;\n    margin-top: 0; }\n  .erxes-message blockquote {\n    border-left: 5px solid #ddd;\n    font-size: 16px;\n    margin: 0;\n    padding: calc($core-spacing / 2) 20px; }\n  .erxes-message pre {\n    background-color: #eaebed;\n    border: 1px solid #ddd;\n    border-radius: 10px;\n    color: #4d4d4d;\n    display: block;\n    font-size: 13px;\n    line-height: 1.42857143;\n    margin: 0;\n    padding: 9.5px;\n    word-break: break-all;\n    word-wrap: break-word; }\n  .erxes-message a {\n    color: #ED3D07;\n    outline: 0; }\n\n.file-wrapper {\n  color: #686868;\n  overflow: hidden;\n  padding-left: 30px;\n  position: relative; }\n  .file-wrapper svg {\n    height: 20px;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 16px; }\n  .file-wrapper span {\n    direction: rtl;\n    display: block;\n    max-width: 150px;\n    overflow: hidden;\n    text-align: left;\n    text-overflow: ellipsis;\n    white-space: nowrap; }\n  .file-wrapper:hover {\n    color: #4f4f4f; }\n\n.download-attachment {\n  display: block;\n  text-decoration: none; }\n  .download-attachment img {\n    -webkit-transition: opacity 0.3s ease-in-out;\n    -moz-transition: opacity 0.3s ease-in-out;\n    -ms-transition: opacity 0.3s ease-in-out;\n    -o-transition: opacity 0.3s ease-in-out;\n    transition: opacity 0.3s ease-in-out; }\n    .download-attachment img:hover {\n      opacity: 0.8; }\n\n.erxes-avatar {\n  width: 40px;\n  height: 40px;\n  position: absolute;\n  bottom: 20px;\n  left: 0; }\n  .erxes-avatar,\n  .erxes-avatar img {\n    border-radius: 50%; }\n  .erxes-avatar img {\n    width: 100%;\n    height: 100%; }\n  .erxes-avatar.top {\n    top: 0; }\n\n.btn-resend {\n  background: #fff;\n  border: 0;\n  border-radius: 10px;\n  color: #686868;\n  cursor: pointer;\n  margin-top: 5px;\n  outline: 0;\n  padding: 5px 15px; }\n  .btn-resend:focus, .btn-resend:hover {\n    background: white; }\n\n.app-message-box {\n  background: #fff;\n  border-radius: 10px;\n  border-top: 3px solid #3b85f4;\n  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.15);\n  color: #3a3a3a;\n  margin-bottom: 8px;\n  padding: 0; }\n  .app-message-box.call-request {\n    margin-bottom: 20px;\n    padding: 16px; }\n    .app-message-box.call-request h5 {\n      margin: 0 0 5px 0;\n      font-size: 15px;\n      font-weight: 700; }\n    .app-message-box.call-request .call-buttons {\n      display: flex; }\n      .app-message-box.call-request .call-buttons button {\n        flex: 1;\n        padding: 8px 16px;\n        font-size: 13px;\n        display: flex;\n        align-items: center;\n        justify-content: center; }\n        .app-message-box.call-request .call-buttons button:last-child {\n          margin-left: 10px; }\n        .app-message-box.call-request .call-buttons button:hover {\n          opacity: 0.9; }\n        .app-message-box.call-request .call-buttons button span {\n          margin-left: 5px; }\n        .app-message-box.call-request .call-buttons button svg {\n          fill: #fff; }\n    .app-message-box.call-request p {\n      margin: 0 0 15px; }\n  .app-message-box.spaced {\n    margin-left: 50px; }\n  .app-message-box.flexible {\n    display: inline-block; }\n  .app-message-box .user-info {\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    padding: 20px;\n    text-align: center; }\n    .app-message-box .user-info h2 {\n      font-size: 18px;\n      margin: 20px 0 0; }\n      .app-message-box .user-info h2 > span {\n        font-size: 24px; }\n    .app-message-box .user-info h4 {\n      font-size: 14px;\n      margin: 0 0 -10px;\n      font-weight: 500;\n      text-align: center; }\n    .app-message-box .user-info img {\n      background: #63d2d6;\n      border: 1px solid #eee;\n      border-radius: 60px;\n      font-size: 20px;\n      height: 60px;\n      line-height: 60px;\n      overflow: hidden;\n      width: 60px; }\n    .app-message-box .user-info strong {\n      font-weight: 500; }\n    .app-message-box .user-info.horizontal {\n      flex-direction: row; }\n      .app-message-box .user-info.horizontal strong {\n        margin-left: 5px; }\n  .app-message-box .call-button {\n    border-top: 1px solid #ddd;\n    padding: 20px;\n    text-align: center; }\n    .app-message-box .call-button h3 {\n      margin-bottom: 15px;\n      margin-top: 0;\n      text-align: center; }\n    .app-message-box .call-button button,\n    .app-message-box .call-button > a {\n      background: #3b85f4;\n      border: 1px solid transparent;\n      border-color: #3b85f4;\n      border-radius: 5px;\n      box-shadow: none;\n      color: #fff;\n      cursor: pointer;\n      font-size: 14px;\n      padding: 10px 20px;\n      text-transform: initial;\n      transition: all 0.3s ease;\n      width: 100%; }\n      .app-message-box .call-button button:hover,\n      .app-message-box .call-button > a:hover {\n        box-shadow: 0 2px 10px 0 #3b85f4; }\n      .app-message-box .call-button button:focus,\n      .app-message-box .call-button > a:focus {\n        outline: 0; }\n    .app-message-box .call-button > a {\n      text-decoration: none;\n      display: block;\n      width: auto;\n      text-align: center; }\n    .app-message-box .call-button .join-call {\n      margin-top: 10px;\n      font-size: 12px;\n      text-transform: lowercase;\n      color: #888; }\n\n.erxes-content {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  overflow: auto;\n  background: #fff; }\n  .erxes-content .erxes-article-content {\n    background: #faf9fb;\n    color: #494949;\n    height: 100%;\n    padding: 30px; }\n    .erxes-content .erxes-article-content h2 {\n      margin-top: 0; }\n    .erxes-content .erxes-article-content .date {\n      color: #686868;\n      font-size: 90%;\n      margin-bottom: 10px; }\n    .erxes-content .erxes-article-content p {\n      margin-bottom: 10px; }\n    .erxes-content .erxes-article-content iframe,\n    .erxes-content .erxes-article-content img {\n      max-width: 100%;\n      height: auto; }\n  .erxes-content .scroll-wrapper {\n    flex: 1;\n    overflow: auto; }\n\n.faq-item {\n  background: #fff; }\n  .faq-item .erxes-right-side {\n    margin-left: 80px; }\n  .faq-item .erxes-left-side {\n    border-radius: 0;\n    margin-right: 10px;\n    background: #f7f6f9;\n    border-radius: 30px; }\n    .faq-item .erxes-left-side i {\n      height: 36px;\n      margin: auto;\n      margin-top: 3px;\n      opacity: 0.7;\n      width: 28px; }\n  .faq-item .description {\n    color: #686868;\n    min-height: 20px; }\n\n.back-category-button {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  border: 0;\n  outline: 0;\n  border-bottom: 1px solid #ddd;\n  background: #f7f6f9;\n  text-transform: uppercase;\n  font-size: 11px;\n  cursor: pointer;\n  transition: all ease 0.3s; }\n  .back-category-button:hover {\n    opacity: 0.8; }\n  .back-category-button > svg {\n    margin-right: 10px; }\n\n.erxes-faq-searchbar {\n  background: #f7f6f9;\n  border-bottom: 1px solid #ddd;\n  padding: 10px 25px;\n  position: relative; }\n  .erxes-faq-searchbar > input {\n    background: #fff;\n    margin: 0;\n    padding-right: 40px; }\n  .erxes-faq-searchbar > svg {\n    fill: #888;\n    position: absolute;\n    right: 40px;\n    top: 20px;\n    width: 16px; }\n\n.empty-articles {\n  align-items: center;\n  color: #686868;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  justify-content: center; }\n  .empty-articles svg {\n    fill: #686868;\n    margin-bottom: 10px; }\n\n.erxes-form {\n  font-size: 14px;\n  margin: 0;\n  overflow: hidden; }\n  .erxes-form .erxes-form-content {\n    list-style: none;\n    margin: 0;\n    position: relative; }\n    .erxes-form .erxes-form-content .erxes-description {\n      color: #5c5c5c;\n      margin-bottom: 10px; }\n  .erxes-form .erxes-result {\n    color: #686868; }\n    .erxes-form .erxes-result p {\n      margin: 0; }\n  .erxes-form .react-datepicker__input-container {\n    display: block; }\n\n.react-datepicker-wrapper {\n  display: block; }\n\n.react-datepicker {\n  border-color: #ddd !important;\n  box-shadow: 0 5px 15px -3px rgba(0, 0, 0, 0.15); }\n  .react-datepicker .react-datepicker__day--selected,\n  .react-datepicker .react-datepicker__day--keyboard-selected {\n    background-color: #ED3D07;\n    border-radius: calc($border-radius / 2); }\n    .react-datepicker .react-datepicker__day--selected:hover,\n    .react-datepicker .react-datepicker__day--keyboard-selected:hover {\n      background-color: #bb3006; }\n  .react-datepicker .react-datepicker__header {\n    background: #faf9fb;\n    border-color: #ddd; }\n    .react-datepicker .react-datepicker__header .react-datepicker__current-month,\n    .react-datepicker .react-datepicker__header .react-datepicker-time__header {\n      font-weight: 500; }\n  .react-datepicker .react-datepicker__triangle {\n    border-bottom-color: #faf9fb !important; }\n    .react-datepicker .react-datepicker__triangle::before {\n      border-bottom-color: #ddd !important; }\n\n.custom-select {\n  display: inline-block;\n  position: relative;\n  font-size: 16px;\n  font-family: \"Poppins\", Helvetica, Arial, sans-serif;\n  width: 200px; }\n\n.custom-select select {\n  display: none;\n  /* Hide the default select element */ }\n\n/* Style for the visible part of the select */\n.custom-select .select-display {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px;\n  border: 1px solid #ccc;\n  cursor: pointer; }\n\n/* Style for the dropdown options */\n.custom-select .select-options {\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  border: 1px solid #ccc;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  background-color: #fff; }\n\n.custom-select .select-option {\n  padding: 10px;\n  cursor: pointer; }\n\n/* Show the options when the select is open */\n.custom-select.open .select-options {\n  display: block; }\n\n.livekitcalls-container {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  max-height: 100%; }\n\n.livekitcalls-content {\n  flex: 1 1 auto; }\n\n.call-container {\n  width: 100%;\n  height: 100%; }\n\n.phone-input-wrapper {\n  display: flex; }\n\n.country-select {\n  background: transparent; }\n\n.erxes-messenger-embed .erxes-message-sender {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0; }\n\n.erxes-message-sender {\n  border-top: 1px solid #f1f1f1;\n  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1);\n  font-size: 12px;\n  min-height: 61px;\n  overflow: auto;\n  position: relative;\n  max-height: 50%;\n  border-bottom-right-radius: 25px;\n  border-bottom-left-radius: 10px; }\n  .erxes-message-sender textarea {\n    -webkit-box-sizing: border-box !important;\n    -moz-box-sizing: border-box !important;\n    -ms-box-sizing: border-box !important;\n    -o-box-sizing: border-box !important;\n    box-sizing: border-box !important;\n    border: 0;\n    color: #686868;\n    font-size: 14px;\n    height: 100%;\n    height: calc(100% - 1px);\n    left: 0;\n    line-height: 20px;\n    max-width: 100%;\n    outline: none;\n    padding: 20px 25px;\n    padding-right: 80px;\n    position: absolute;\n    resize: none;\n    top: 0;\n    width: 100%;\n    overflow: hidden; }\n    .erxes-message-sender textarea:focus {\n      -webkit-box-shadow: none !important;\n      -moz-box-shadow: none !important;\n      -ms-box-shadow: none !important;\n      -o-box-shadow: none !important;\n      box-shadow: none !important; }\n  .erxes-message-sender .ctrl {\n    position: absolute;\n    right: 15px;\n    top: 13px; }\n    .erxes-message-sender .ctrl .ctrl-item {\n      float: left;\n      width: 35px;\n      height: 35px;\n      line-height: 35px;\n      margin: 0;\n      cursor: pointer;\n      opacity: 0.7;\n      text-align: center;\n      font-size: 14px; }\n      .erxes-message-sender .ctrl .ctrl-item:hover {\n        opacity: 1; }\n      .erxes-message-sender .ctrl .ctrl-item svg {\n        height: 36px; }\n      .erxes-message-sender .ctrl .ctrl-item input[type='file'] {\n        display: none; }\n  .erxes-message-sender .loader {\n    margin: 0;\n    right: 20px;\n    top: 17px; }\n\n.erxes-notification {\n  background: #faf9fb;\n  border-color: transparent;\n  border-radius: 10px;\n  border-style: solid;\n  border-width: 1px;\n  bottom: 83px;\n  box-shadow: 0 2px 15px 2px rgba(0, 0, 0, 0.2);\n  box-sizing: border-box;\n  display: flex;\n  max-width: 100%;\n  position: absolute;\n  right: 8px;\n  width: 330px;\n  z-index: 9998; }\n  .erxes-notification > button {\n    position: absolute;\n    right: 0; }\n  .erxes-notification.full-message {\n    height: calc(100% - 110px); }\n  .erxes-notification .close-notification {\n    background: #d5d5d5;\n    border-radius: 50%;\n    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.1);\n    height: 22px;\n    opacity: 1;\n    position: absolute;\n    right: 10px;\n    text-align: center;\n    top: 10px;\n    transition: all .3s ease;\n    width: 22px; }\n    .erxes-notification .close-notification:hover {\n      background: #bbbbbb; }\n    .erxes-notification .close-notification svg {\n      height: 22px;\n      width: 14px; }\n  .erxes-notification .flex-notification {\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    width: 100%;\n    max-height: 100%; }\n  .erxes-notification .flex-notification-container {\n    width: 100%; }\n  .erxes-notification:hover {\n    box-shadow: 0 2px 15px 2px rgba(0, 0, 0, 0.25);\n    cursor: pointer; }\n    .erxes-notification:hover .close-notification {\n      opacity: 1; }\n  .erxes-notification .notification-body {\n    -webkit-box-orient: vertical;\n    color: #686868;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    line-height: 22px;\n    margin-bottom: 20px;\n    overflow: hidden;\n    padding: 0 20px;\n    word-wrap: break-word; }\n    .erxes-notification .notification-body.full-message {\n      display: block;\n      flex: 1;\n      margin-bottom: 0;\n      overflow: auto;\n      padding: 0 20px 20px; }\n    .erxes-notification .notification-body img {\n      max-width: 100%; }\n  .erxes-notification .user-info {\n    align-items: center;\n    display: flex;\n    flex-direction: row;\n    flex-shrink: 0;\n    padding: 20px 20px calc($core-spacing / 2); }\n    .erxes-notification .user-info .erxes-avatar {\n      margin-right: 10px;\n      position: initial; }\n\n.bot-message {\n  margin: 0 20px 5px 50px;\n  max-width: 100%; }\n  .bot-message img {\n    max-width: 100%;\n    display: inherit; }\n  .bot-message .image-message {\n    border-radius: 8px;\n    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2); }\n\n.cards-wrapper {\n  position: relative; }\n  .cards-wrapper .cards-navigation {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    right: 0;\n    display: flex;\n    align-items: center;\n    pointer-events: none; }\n    .cards-wrapper .cards-navigation .arrow {\n      margin-bottom: 60px;\n      width: 36px;\n      height: 36px;\n      display: flex;\n      border-radius: 100%;\n      box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.35);\n      align-items: center;\n      justify-content: center;\n      transition: all .3s;\n      cursor: pointer;\n      background: #fff;\n      pointer-events: all;\n      z-index: 2; }\n      .cards-wrapper .cards-navigation .arrow.next {\n        margin-left: auto;\n        margin-right: 8px; }\n      .cards-wrapper .cards-navigation .arrow.prev {\n        margin-left: -18px; }\n\n.cards {\n  display: flex;\n  align-items: flex-start;\n  transition: transform .3s; }\n\n.card-item {\n  flex-shrink: 0;\n  margin-right: 15px;\n  width: 240px;\n  background: #fff;\n  border-radius: 8px;\n  border: 1px solid #dbe1e8;\n  overflow: hidden;\n  opacity: 0.7;\n  transition: opacity .3s;\n  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.1);\n  user-select: none; }\n  .card-item.active {\n    opacity: 1; }\n  .card-item .card-content {\n    padding: 8px 16px 16px 16px; }\n    .card-item .card-content p {\n      color: #686868; }\n  .card-item h4, .card-item p {\n    margin-top: 8px;\n    margin-bottom: 0; }\n  .card-item .card-actions {\n    margin-bottom: 1px; }\n    .card-item .card-actions .card-action {\n      padding: 8px 16px;\n      border-top: 1px solid #dbe1e8;\n      display: block;\n      text-align: center;\n      font-weight: 500; }\n      .card-item .card-actions .card-action:hover {\n        background: #faf9fb;\n        cursor: pointer; }\n\n.quick-replies {\n  display: flex;\n  flex-wrap: wrap;\n  margin-left: -4px; }\n  .quick-replies .reply-button {\n    padding: 5px 15px;\n    border: 1px solid #673fbd;\n    margin: 4px;\n    border-radius: 20px;\n    font-weight: 500;\n    color: #333; }\n    .quick-replies .reply-button:hover {\n      opacity: 0.8;\n      cursor: pointer; }\n\n.bot-indicator {\n  display: inline-block;\n  margin-bottom: 1px; }\n  .bot-indicator span {\n    height: 6px;\n    width: 6px;\n    float: left;\n    margin: 0 2px;\n    background-color: #555;\n    display: block;\n    border-radius: 50%;\n    animation-name: wave;\n    animation-duration: 1.3s;\n    animation-timing-function: ease-in-out;\n    animation-iteration-count: infinite; }\n  .bot-indicator span:nth-of-type(1) {\n    animation-delay: 0.2s; }\n  .bot-indicator span:nth-of-type(2) {\n    animation-delay: 0.3s; }\n  .bot-indicator span:nth-of-type(3) {\n    animation-delay: 0.4s; }\n\n@keyframes wave {\n  0% {\n    transform: translateY(0px); }\n  28% {\n    transform: translateY(-5px); }\n  44% {\n    transform: translateY(0px); } }\n\n.skill-content {\n  transition: transform .3s;\n  margin: -5px 0;\n  text-align: right; }\n\n.skill-card {\n  margin: 5px 0;\n  border: 1px solid rgba(0, 0, 0, 0.03);\n  display: inline-block;\n  text-align: center;\n  line-height: 18px;\n  white-space: nowrap;\n  font-size: 14px;\n  border-radius: 20px;\n  box-shadow: 0 1px 5px 1px rgba(0, 0, 0, 0.1); }\n  .skill-card:hover {\n    cursor: pointer;\n    box-shadow: 0 1px 10px 2px rgba(0, 0, 0, 0.15);\n    opacity: 0.9; }\n\n.erxes-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 2147483647; }\n\n.erxes-modal {\n  position: absolute;\n  border: none;\n  background: white;\n  overflow: auto;\n  border-radius: 8px;\n  outline: none;\n  padding: 20px;\n  width: 260px;\n  left: 50%;\n  top: 80px;\n  transform: translateX(-50%);\n  outline: 0;\n  max-width: 100%;\n  animation-delay: 0s;\n  animation-duration: .1s;\n  box-shadow: rgba(66, 66, 66, 0.3) 0px 3px 60px 0px; }\n  .erxes-modal h5 {\n    margin: 0 0 18px;\n    font-weight: 500; }\n  .erxes-modal .modal-footer {\n    display: flex;\n    justify-content: flex-end; }\n    .erxes-modal .modal-footer .erxes-button {\n      margin-left: 8px;\n      padding: 8px 16px; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
